// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:34:37.947Z
// Property: Winchester Apartments (ID: 6767906449165644)
// Collections: 25 amenities, 13 floorplans (live), 40 photos, 73 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165644",
  "property_external_id": "sz1d125",
  "property_zillow_url": "https://www.zillow.com/homedetails/5509-SW-9th-Ave-Amarillo-TX-79106/205430205_zpid/",
  "property_apartments_url": "https://www.apartments.com/winchester-apartments-amarillo-tx/sz1d125/",
  "property_google_business_url": "https://www.google.com/maps/place/Winchester+Apartments/data=!4m2!3m1!1s0x0:0xfc11ec57a1c8df48?sa=X&ved=2ahUKEwjV-7yjg72SAxXnjYkEHTQNDNIQ_BJ6BAgLEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/in/winchester-apartments-105bbb70",
  "property_hubspot_id": "5059653703",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "winchester-apartments",
  "property_name": "Winchester Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/tx/amarillo/winchester/",
  "property_domain": null,
  "property_address": "5509 S.W. 9th Avenue",
  "property_full_address": "5509 S.W. 9th Avenue, Amarillo, TX, 79106",
  "property_address_1": "5509 S.W. 9th Avenue",
  "property_address_2": null,
  "property_address_city": "Amarillo",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79106",
  "property_address_country": null,
  "property_address_county": "Randall County",
  "property_neighborhood_address": "Amarillo",
  "property_address_latitude": "35.2051",
  "property_address_longitude": "-101.9009",
  "property_email": "winchester@caseusa.com",
  "property_phone": "(806) 835-5080",
  "property_call_tracking_phone": "833-309-1691",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Winchester Apartments in Amarillo, Texas, a world of comfort awaits. Choose from spacious one, two, or three-bedroom floor plans designed for modern living. Enjoy amenities like a sparkling pool, fitness center, and inviting clubhouse. Embrace the perfect blend of style and convenience—your new home is just a click away! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Winchester Apartments, the perfect blend of comfort and convenience in the heart of Amarillo, Texas. Our thoughtfully designed floor plans feature one, two, and three-bedroom apartments, ensuring you find the perfect space to call home. With a range of modern amenities at your disposal, you’ll enjoy a lifestyle of ease and enjoyment.\n\nDive into relaxation at our sparkling pool or maintain your active lifestyle in our state-of-the-art fitness center. Gather with friends in our welcoming clubhouse or take advantage of our well-equipped business center for all your work-from-home needs. Our dedicated on-site management and maintenance team is here to ensure your living experience is hassle-free.\n\nEach apartment boasts desirable features such as air conditioning, high ceilings, and hardwood floors, creating a cozy and inviting atmosphere. Enjoy the convenience of modern appliances, including a dishwasher, microwave, and washer/dryer hookups, along with ample storage space and walk-in closets. Many units also include balconies or patios, perfect for enjoying the beautiful Texas weather. \n\nOur gated community offers both security and peace of mind, while the landscaped courtyard provides a serene escape. With high-speed internet access, you’ll stay connected and engaged, whether for work or leisure.\n\nFind your new home today at Winchester Apartments! Browse our availability or schedule a tour to explore our vibrant community. Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4c-d6d8-7508-9dd1-08b406da0d26.webp",
  "property_featured_image_media": {
    "alt_text": "The entrance to a multifamily property with a grand facade, columns, and landscaping.",
    "public_id": "019cfb4c-d6d8-7508-9dd1-08b406da0d26",
    "storage_key": "property/6767906449165644/019cfb4c-d6d8-7508-9dd1-08b406da0d26.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "256",
  "property_year_built": "2005",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.21875",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "40",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://winchesterapartmentsamarillo.securecafe.com/onlineleasing/winchester-apartments/floorplans.aspx",
  "property_resident_portal_url": "https://winchesterapartmentsamarillo.securecafe.com/residentservices/winchester-apartments/userlogin.aspx",
  "property_apply_now_url": "https://winchesterapartmentsamarillo.securecafe.com/onlineleasing/winchester-apartments/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-2c95-7568-95df-c01524328a7f.webp",
  "property_primary_logo_media": {
    "alt_text": "Winchester Apartments logo",
    "public_id": "019cfb4d-2c95-7568-95df-c01524328a7f",
    "storage_key": "property/6767906449165644/019cfb4d-2c95-7568-95df-c01524328a7f.webp",
    "width": 300,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4e-2680-70ff-9459-1feb1d4fc671.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb4e-2680-70ff-9459-1feb1d4fc671",
    "storage_key": "property/6767906449165644/019cfb4e-2680-70ff-9459-1feb1d4fc671.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4e-348a-75f8-a6c1-98fe5f084c62.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Winchester Apartments logo",
    "public_id": "019cfb4e-348a-75f8-a6c1-98fe5f084c62",
    "storage_key": "property/6767906449165644/019cfb4e-348a-75f8-a6c1-98fe5f084c62.webp",
    "width": 300,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4e-4413-72bc-abea-75eb14e3a8d9.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Winchester Apartments logo",
    "public_id": "019cfb4e-4413-72bc-abea-75eb14e3a8d9",
    "storage_key": "property/6767906449165644/019cfb4e-4413-72bc-abea-75eb14e3a8d9.webp",
    "width": 300,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#000000",
  "property_secondary_color": "#924130",
  "property_font_color": null,
  "property_color_4": "#e5dbcc",
  "property_color_3": "#324d58",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": "961 - 961",
  "property_sqft_min": "961",
  "property_sqft_max": "961",
  "property_price_range": "1374 - 1374",
  "property_price_min": "1374",
  "property_price_max": "1374",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/WinchesterApts/posts/searching-for-a-new-home-in-amarillo-winchester-apartments-offers-spacious-floor/1422837283187873/",
  "property_instagram_url": "https://www.instagram.com/winchesterapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ38lvbNBRAYcRSN_IoVfsEfw",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/winchester-apartments-amarillo-2",
  "property_tiktok_url": "https://www.tiktok.com/@winchesterapartments",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Winchester Apartments",
  "property_home_romance_title": "Live Your Best Life in a Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Winchester Apartments in Amarillo, Texas, where comfort meets style. Choose from our spacious one to three-bedroom floor plans, each boasting modern conveniences like in-unit washers, gourmet kitchens, and private balconies. Enjoy resort-style amenities, including a sparkling pool, fitness center, and inviting clubhouse. Your elevated lifestyle starts here!",
  "property_home_floorplans_blurb": "Welcome to Winchester Apartments in Amarillo, Texas, where comfort meets style! Choose from our thoughtfully designed one, two, and three-bedroom floor plans, tailored to suit your lifestyle. Browse our available apartments today and unlock the door to your ideal living space in a vibrant community. Your perfect home awaits!",
  "property_home_gallery_blurb": "Welcome to Winchester Apartments in Amarillo, Texas—where comfort meets style. Choose from thoughtfully designed one, two, or three-bedroom floor plans adorned with modern amenities. Enjoy a refreshing dip in the pool, a workout in the fitness center, or unwind in your private balcony. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Winchester Apartments in Amarillo, Texas, immerse yourself in a vibrant community brimming with excitement. Enjoy the nearby Wonderland Amusement Park, explore the serene Amarillo Botanical Gardens, or take a leisurely stroll through John Stiff Memorial Park. Your perfect home, combined with local treasures, awaits you!",
  "property_home_reviews_blurb": "Nestled in the heart of Amarillo, Winchester Apartments offers a peaceful sanctuary with lush greenery and a friendly atmosphere. Residents rave about our dedicated staff, with one noting, \"Ryan always helpful,\" making your living experience truly exceptional. Come see why our community is the perfect place to call home!",
  "property_neighborhood_blurb": "Nestled in the heart of Amarillo, Winchester Apartments offers an ideal blend of comfort and convenience. Enjoy nearby attractions like the Amarillo Botanical Gardens, Wonderland Amusement Park, and the vibrant Thompson Memorial Park. With diverse floor plans and a lively community, life here pulses with endless opportunities for adventure!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Winchester Apartments in Amarillo, Texas, where your comfort meets style. Choose from spacious one, two, or three-bedroom layouts adorned with modern amenities, including a refreshing pool, state-of-the-art fitness center, and serene courtyards. Experience elevated living with air conditioning, hardwood floors, and luxurious walk-in closets.",
  "property_applynow_blurb": "At Winchester Apartments in Amarillo, Texas, comfort meets convenience within stylish one to three-bedroom floor plans. Enjoy amenities like a sparkling pool, modern fitness center, and inviting clubhouse. With spacious balconies and high ceilings, your perfect home awaits. Start your journey by leasing online today!",
  "property_contactus_blurb": "At Winchester Apartments in Amarillo, Texas, we offer versatile floor plans to suit your lifestyle—choose from cozy one-bedroom, spacious two-bedroom, or expansive three-bedroom layouts. For personalized assistance or inquiries, connect with our leasing team today and step into your ideal home. Your perfect apartment awaits!",
  "property_faqs_blurb": "At Winchester Apartments in Amarillo, Texas, we offer a diverse range of floor plans—one, two, and three bedrooms—perfectly tailored to your lifestyle. Uncover essential insights by browsing our FAQs page, where you'll find answers to your queries and experience the vibrant community waiting for you.",
  "property_floorplans_blurb": "At Winchester Apartments in Amarillo, Texas, your ideal home awaits. With thoughtfully designed one, two, and three-bedroom floor plans, each space exudes comfort and style. Dive into our diverse options and envision your next chapter in a welcoming community. Browse our available apartment homes and find your perfect floor plan!",
  "property_gallery_blurb": "At Winchester Apartments in Amarillo, Texas, vibrant living awaits! Choose from spacious one, two, or three-bedroom floor plans, complemented by exceptional amenities like a shimmering pool, state-of-the-art fitness center, and inviting clubhouse. Picture yourself enjoying the comfort of hardwood floors and sunny balconies in your new home!",
  "property_interactivemap_blurb": "At Winchester Apartments in Amarillo, Texas, your perfect home awaits! Choose from exquisite one, two, or three-bedroom layouts, featuring modern amenities like a sparkling pool, fitness center, and inviting clubhouse. Use our interactive community map to navigate available options and find your ideal residence—comfort and convenience are just a click away!",
  "property_pets_blurb": "Nestled in the heart of Amarillo, Winchester Apartments harmoniously blends comfort with style. Embrace a vibrant lifestyle with our pet-friendly community—perfect for furry companions. Enjoy spacious living, lush green spaces, and convenient amenities, all while making unforgettable memories in your new home. Your adventure begins at Winchester Apartments!",
  "property_referafriend_blurb": "At Winchester Apartments in Amarillo, Texas, your perfect home awaits—from cozy one-bedroom retreats to spacious three-bedroom designs. Enjoy stylish living and vibrant community life. Great friends make great neighbors—invite a friend to experience the comfort and charm of Winchester Apartments today!",
  "property_residentaccess_blurb": "Welcome to Winchester Apartments in Amarillo, Texas, where comfort meets convenience. Choose from our inviting one, two, or three-bedroom floor plans designed for your lifestyle. Manage your living experience effortlessly—log in to your resident portal to pay rent, schedule maintenance, and stay connected to your community!",
  "property_reviews_blurb": "At Winchester Apartments in Amarillo, our residents enjoy a serene, green oasis, with a community that feels like home. As one resident shares, “This complex and the staff that operates it continue to exceed my expectations!” Join a vibrant community where friendly faces and exceptional service await you!",
  "property_created_at": "1753982397794",
  "property_scheduletour_blurb": "At Winchester Apartments in Amarillo, Texas, you’ll find the perfect living space tailored to your lifestyle—choose from one, two, or three-bedroom floor plans. Schedule a tour today and hear firsthand why our residents love calling this vibrant community home! Your ideal apartment awaits!",
  "property_thankyou_blurb": "Thank you for reaching out to Winchester Apartments in Amarillo, Texas! With inviting one, two, and three-bedroom floor plans, your ideal home awaits. Our team is eager to assist you in finding the perfect space. Stay tuned for a prompt response—we can’t wait to welcome you to our community!",
  "property_virtualtours_blurb": "At Winchester Apartments in Amarillo, Texas, find your perfect home among our thoughtfully designed one, two, and three-bedroom floor plans. Immerse yourself in our vibrant community by taking a virtual tour today—your future oasis awaits just a click away! Experience comfort, style, and convenience all in one place.",
  "property_copyright": "2025 All Rights Reserved. Winchester Apartments",
  "property_seo_title_home": "Winchester Apartments |  Apartments in Amarillo, Texas",
  "property_seo_description_home": "Experience comfort at Winchester Apartments in Amarillo, TX! Choose from spacious 1-3 bedroom floor plans with great amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Amarillo, Texas Apartments for Rent",
  "property_seo_description_floorplans": "Discover your perfect home at Winchester Apartments in Amarillo, TX, offering cozy one-bedroom to spacious three-bedroom floor plans!",
  "property_seo_title_amenities": "Amenities | Amarillo, Texas Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at Winchester Apartments in Amarillo, TX, featuring a refreshing pool and state-of-the-art fitness center!",
  "property_seo_title_gallery": "Gallery | Apartments in Amarillo, Texas",
  "property_seo_description_gallery": "Discover your dream home at Winchester Apartments in Amarillo, TX. Explore our spacious floor plans and inviting amenities through stunning photos!",
  "property_seo_title_virtualtours": "Virtual Tours | Winchester Apartments Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Winchester Apartments in Amarillo! Take a virtual tour of our stylish one, two, and three-bedroom homes today. Your dream space awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Winchester Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Winchester Apartments in Amarillo! Enjoy stunning amenities, spacious floor plans, and an interactive map to guide your search.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Amarillo, Texas",
  "property_seo_description_neighborhood": "Uncover the charm of Amarillo from Winchester Apartments! Discover local favorites and attractions just steps from your door. Dive into community vibes today!",
  "property_seo_title_contact": "Contact Us | Winchester Apartments",
  "property_seo_description_contact": "Connect with Winchester Apartments in Amarillo, TX. Whether you're seeking a cozy one-bedroom or a spacious three-bedroom, our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Amarillo, Texas",
  "property_seo_description_faqs": "Get answers to your burning questions at Winchester Apartments in Amarillo. Learn about our floor plans, amenities, and life in our vibrant community today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Amarillo, Texas",
  "property_seo_description_reviews": "Join the Winchester Apartments community in Amarillo, Texas, and see what our residents love about their stylish homes and top-notch amenities!",
  "property_seo_title_applynow": "Apply Now | Apartments in Amarillo, Texas",
  "property_seo_description_applynow": "Experience the comfort of Winchester Apartments in Amarillo, TX! Choose from spacious floor plans with fantastic amenities. Lease your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | Winchester Apartments",
  "property_seo_description_residentaccess": "Experience seamless living at Winchester Apartments! Log in to easily pay rent, request maintenance, and connect with your community from anywhere in Amarillo.",
  "property_seo_title_referafriend": "Refer A Friend | Winchester Apartments",
  "property_seo_description_referafriend": "Share the love at Winchester Apartments! Refer a friend and enjoy a vibrant community in Amarillo, Texas. Great friends foster great living—join us!",
  "property_seo_title_scheduletour": "Schedule a Tour | Winchester Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Winchester Apartments in Amarillo, TX. Schedule a tour today and envision your new lifestyle in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Winchester Apartments",
  "property_seo_description_privacy": "At Winchester Apartments in Amarillo, TX, your privacy matters. Learn how we safeguard your information. Read our privacy policy for peace of mind today!",
  "property_seo_title_accessibility": "Website Accessibility | Winchester Apartments",
  "property_seo_description_accessibility": "Discover the charm of Winchester Apartments in Amarillo, TX, where digital inclusion ensures everyone feels at home. Access our resources today!",
  "property_seo_title_sitemap": "Sitemap | Winchester Apartments",
  "property_seo_description_sitemap": "Explore Winchester Apartments in Amarillo—check our sitemap for amenities, floor plans, and community features designed just for you!",
  "property_seo_title_thankyou": "Thank You | Winchester Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Winchester Apartments in Amarillo, TX! A team member will be in touch soon to discuss your new home and next steps.",
  "property_seo_title_pets": "Pet Policy | Apartments in Amarillo, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866189709",
  "amenities": [
    {
      "id": "ec_6d7658187e53d8bf953b99f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127397518",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22b3dece68b440cf1423b737",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127397520",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aee3b5b766042a65709345b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127397523",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b59f6e90f8a886668aed9a51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127397524",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c630c71d89411fc3702892e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127397525",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59313a7dd0185595960543b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127397526",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63436091a5e5bb111701d228",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127397527",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68c7cc6d71f3a1ba258a4136",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127397528",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1ed3c507945afca640ba475",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127397529",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d50c13000783e66625a7f16f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127397530",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4f5cbcac3c34407df83bb42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127397531",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1ec6ef25150919b16f72089",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127397532",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa60c0c0d1d115a06fdfb64b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "128017200",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70ab261b0973f5e53fb3e6f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "128042524",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c5c2badfb932710dbbeeda0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127398981",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec78c43e5489b82c3e678511",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127398982",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a97c82f4af2c2eb8ab27ed2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127398983",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42f16fe6b8e5034b56c2148b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127398984",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de56ba97e1ed2250bf394d2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127398985",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46c1a5b8c874b03eb43b379f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127398986",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8d31b8e5d6ce5b5bba5b2d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127398987",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2964fe3a362a5f48624ec210",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127398988",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8430cd7979ea763b29d55273",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127398989",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b41b48d1dcff4ddf8987472f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127398990",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e59e12b5fddfb7d8102107db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "yardi",
      "external_id": "127398991",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_f8be3086-69b9-4ba5-be34-748fb6e776ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-d4fe-739d-b1a7-cc3f192cc885.webp",
      "image_media": {
        "alt_text": "A modern bedroom with a tufted headboard, orange comforter, and a window with blinds.",
        "public_id": "019f0071-d4fe-739d-b1a7-cc3f192cc885",
        "storage_key": "property/6767906449165644/019f0071-d4fe-739d-b1a7-cc3f192cc885.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Discover comfort in our spacious bedrooms featuring stylish finishes, plush carpeting, and ample natural light through large windows. Enjoy your private retreat.",
      "link": "",
      "alt_text": "A modern bedroom with a tufted headboard, orange comforter, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c36a04f9-e0da-4964-940f-7f694e0d90d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-e0bd-7776-b7ba-65f06a0a3165.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a queen-size bed, tufted gray headboard, peach and green bedding, large window, wooden dresser, and bedside lamp.",
        "public_id": "019f0071-e0bd-7776-b7ba-65f06a0a3165",
        "storage_key": "property/6767906449165644/019f0071-e0bd-7776-b7ba-65f06a0a3165.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this inviting bedroom, featuring a stylish tufted headboard, plush bedding, and ample natural light from the large window. A comfortable and elegant space designed for your ultimate comfort.",
      "link": "",
      "alt_text": "Spacious bedroom with a queen-size bed, tufted gray headboard, peach and green bedding, large window, wooden dresser, and bedside lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3770e421-adef-45ba-b2c8-1abc100e9f80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-cc49-7399-bc76-0d9ac02ba59c.webp",
      "image_media": {
        "alt_text": "View of a modern bedroom with a bed featuring an orange blanket and green checkered throw, abstract art on the wall, and an open closet.",
        "public_id": "019f0071-cc49-7399-bc76-0d9ac02ba59c",
        "storage_key": "property/6767906449165644/019f0071-cc49-7399-bc76-0d9ac02ba59c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A brightly lit bedroom showcases a comfortable bed with a stylish orange and green checkered comforter, complemented by contemporary wall art and ample closet space.",
      "link": "",
      "alt_text": "View of a modern bedroom with a bed featuring an orange blanket and green checkered throw, abstract art on the wall, and an open closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fee523b0-c4ea-4922-a0f9-c37a83d8a134",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-ac26-77cd-9ee0-666b90b48a2f.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, wooden trim, white appliances, and stainless steel sink.",
        "public_id": "019f0071-ac26-77cd-9ee0-666b90b48a2f",
        "storage_key": "property/6767906449165644/019f0071-ac26-77cd-9ee0-666b90b48a2f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample cabinet space, a full-size range, microwave, dishwasher, and a double basin sink.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, wooden trim, white appliances, and stainless steel sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_df078d2f-6d02-48c6-9850-0b54552dd1d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-bab0-778e-bde3-cb1e88c9d791.webp",
      "image_media": {
        "alt_text": "Laundry room with white walls, tile floor, wire shelf with detergent, laundry icons, and a decorative plant.",
        "public_id": "019f0071-bab0-778e-bde3-cb1e88c9d791",
        "storage_key": "property/6767906449165644/019f0071-bab0-778e-bde3-cb1e88c9d791.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit laundry area, complete with a wire shelf for supplies and ample space for your washer and dryer.",
      "link": "",
      "alt_text": "Laundry room with white walls, tile floor, wire shelf with detergent, laundry icons, and a decorative plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_20ae8ebe-677f-4a4c-99ad-8c9ba14723b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-b1a0-738b-87e2-24ee90aae425.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a single vanity, large mirror, and decorative plants. Laundry closet entrance visible.",
        "public_id": "019f0071-b1a0-738b-87e2-24ee90aae425",
        "storage_key": "property/6767906449165644/019f0071-b1a0-738b-87e2-24ee90aae425.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Bright and inviting bathroom featuring a spacious vanity, stylish decor, and easy access to an in-unit laundry area for your convenience.",
      "link": "",
      "alt_text": "Modern bathroom with a single vanity, large mirror, and decorative plants. Laundry closet entrance visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c799461f-3168-493a-8c01-2419b615440b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-ac92-71a8-97aa-aa05a649deda.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with double sinks, wooden cabinets, and a large mirror.",
        "public_id": "019f0071-ac92-71a8-97aa-aa05a649deda",
        "storage_key": "property/6767906449165644/019f0071-ac92-71a8-97aa-aa05a649deda.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with ample counter space, wooden cabinetry, and a clean white tub and shower area.",
      "link": "",
      "alt_text": "Bathroom vanity with double sinks, wooden cabinets, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78faa46b-50af-4ce0-a7db-8fd845eea41b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-934b-775a-91e9-6e3c45cf3a4f.webp",
      "image_media": {
        "alt_text": "A modern apartment dining area with a glass-top table, four white upholstered chairs, wall art, and a large plant.",
        "public_id": "019f0071-934b-775a-91e9-6e3c45cf3a4f",
        "storage_key": "property/6767906449165644/019f0071-934b-775a-91e9-6e3c45cf3a4f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals in this stylish dining area featuring a contemporary glass table and comfortable chairs. Natural light streams in through the patio door, enhancing the bright, inviting atmosphere.",
      "link": "",
      "alt_text": "A modern apartment dining area with a glass-top table, four white upholstered chairs, wall art, and a large plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_198f44fb-f117-4fd4-a46d-30c98c7de7e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-8852-712b-8b1f-9632294edc17.webp",
      "image_media": {
        "alt_text": "Spacious living room with a comfortable sofa, coffee table, and TV, leading into a cozy bedroom.",
        "public_id": "019f0071-8852-712b-8b1f-9632294edc17",
        "storage_key": "property/6767906449165644/019f0071-8852-712b-8b1f-9632294edc17.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in the inviting living room, featuring modern decor, a large window for natural light, and plush carpeting. Seamlessly connect to your private bedroom and a convenient kitchen area.",
      "link": "",
      "alt_text": "Spacious living room with a comfortable sofa, coffee table, and TV, leading into a cozy bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bba51354-64a4-4de8-91d8-b2b24e6971cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-bded-77ba-829d-e86ec0e353ee.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a dark wood bed frame, orange and green checkered throw, and decorative pillows.",
        "public_id": "019f0071-bded-77ba-829d-e86ec0e353ee",
        "storage_key": "property/6767906449165644/019f0071-bded-77ba-829d-e86ec0e353ee.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, featuring a stylish dark wood bed, plush carpeting, and abundant natural light.",
      "link": "",
      "alt_text": "Cozy bedroom with a dark wood bed frame, orange and green checkered throw, and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b44e96fd-e6da-45a9-9f6a-155fe37697fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-8541-742c-a15c-f25202161114.webp",
      "image_media": {
        "alt_text": "Modern living room with a sofa, coffee table, and TV displaying a scenic view. Bedroom visible through doorway.",
        "public_id": "019f0071-8541-742c-a15c-f25202161114",
        "storage_key": "property/6767906449165644/019f0071-8541-742c-a15c-f25202161114.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this stylish apartment, featuring a welcoming living area and a private bedroom. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Modern living room with a sofa, coffee table, and TV displaying a scenic view. Bedroom visible through doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aad843cb-dfcb-4774-bf1b-3f4ca936353b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-53ef-7601-9ea6-f24681fc1606.webp",
      "image_media": {
        "alt_text": "In-unit laundry closet with washer/dryer hookups, shelf with detergents, and a wicker basket.",
        "public_id": "019f0071-53ef-7601-9ea6-f24681fc1606",
        "storage_key": "property/6767906449165644/019f0071-53ef-7601-9ea6-f24681fc1606.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry closet featuring washer and dryer hookups, a shelf stocked with detergents, and a decorative wicker basket, making chores a breeze.",
      "link": "",
      "alt_text": "In-unit laundry closet with washer/dryer hookups, shelf with detergents, and a wicker basket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b22c0c8-7fd6-404a-871a-5ced947cc8ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-a6a6-71de-ae8f-b07d1e96aa50.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, light wood cabinets, and a decorative rug.",
        "public_id": "019f0071-a6a6-71de-ae8f-b07d1e96aa50",
        "storage_key": "property/6767906449165644/019f0071-a6a6-71de-ae8f-b07d1e96aa50.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "This apartment kitchen features clean white appliances, including a stove, microwave, and refrigerator, complemented by light wood cabinetry and stylish decorative accents.",
      "link": "",
      "alt_text": "Kitchen with white appliances, light wood cabinets, and a decorative rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ba533bf9-97f7-487c-8771-df7b43880ea1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-3fb8-7278-8603-33ac4e0f4ecb.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019f0071-3fb8-7278-8603-33ac4e0f4ecb",
        "storage_key": "property/6767906449165644/019f0071-3fb8-7278-8603-33ac4e0f4ecb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable seating. Enjoy the resort-style amenities at our community.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d654a824-96b9-492b-87a9-99bd0902ccb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-46ee-716f-be85-bc9f7e5e04c3.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, large mirror, modern lighting, and a dedicated pet area featuring a dog bed and food bowls on wood-look flooring.",
        "public_id": "019f0071-46ee-716f-be85-bc9f7e5e04c3",
        "storage_key": "property/6767906449165644/019f0071-46ee-716f-be85-bc9f7e5e04c3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "This modern bathroom features a spacious vanity with ample storage and contemporary decor. Enjoy the convenience of a dedicated pet area, perfect for your furry friends, all on stylish wood-look flooring.",
      "link": "",
      "alt_text": "Bathroom with a vanity, large mirror, modern lighting, and a dedicated pet area featuring a dog bed and food bowls on wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5580d4a7-a0a1-40f5-95ee-3f1c584de34a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-810f-7726-a54e-fe2c6178f786.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, accent chair, coffee table, and dining set.",
        "public_id": "019f0071-810f-7726-a54e-fe2c6178f786",
        "storage_key": "property/6767906449165644/019f0071-810f-7726-a54e-fe2c6178f786.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Comfortable and stylish living and dining area with plush seating, a modern coffee table, and a well-appointed dining set.",
      "link": "",
      "alt_text": "Living room with a sofa, accent chair, coffee table, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_34c19050-4275-4ef0-8c37-0c5c59abc8c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-3c1d-75bf-b4be-03394ec82f6b.webp",
      "image_media": {
        "alt_text": "Bright living room with a large sectional sofa, coffee table, and dining nook.",
        "public_id": "019f0071-3c1d-75bf-b4be-03394ec82f6b",
        "storage_key": "property/6767906449165644/019f0071-3c1d-75bf-b4be-03394ec82f6b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa and a cozy dining nook, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Bright living room with a large sectional sofa, coffee table, and dining nook.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6cbeee1-565f-4be8-9fc8-b40fec8cb1ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-1b43-7638-a225-58c6c50ee974.webp",
      "image_media": {
        "alt_text": "Modern apartment living room with a large TV, coffee table, and an adjacent kitchen featuring white appliances.",
        "public_id": "019f0071-1b43-7638-a225-58c6c50ee974",
        "storage_key": "property/6767906449165644/019f0071-1b43-7638-a225-58c6c50ee974.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy the comfort and convenience of an open-concept living room that flows seamlessly into the modern kitchen, ideal for entertaining or quiet evenings at home.",
      "link": "",
      "alt_text": "Modern apartment living room with a large TV, coffee table, and an adjacent kitchen featuring white appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_42422f47-a4ac-4cbe-a01f-de320aa46bd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-5ad2-7338-b647-5b575416b59c.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, nightstand, and decor.",
        "public_id": "019f0071-5ad2-7338-b647-5b575416b59c",
        "storage_key": "property/6767906449165644/019f0071-5ad2-7338-b647-5b575416b59c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed, elegant nightstand, and tasteful wall art.",
      "link": "",
      "alt_text": "Stylish bedroom with a king-size bed, nightstand, and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e82e6029-ad43-4766-8d71-033013bda7fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0070-fdeb-72bf-b189-caf9f79f7724.webp",
      "image_media": {
        "alt_text": "A brightly lit living room with a light gray sofa, a blue textured armchair, a coffee table, a TV, and large windows.",
        "public_id": "019f0070-fdeb-72bf-b189-caf9f79f7724",
        "storage_key": "property/6767906449165644/019f0070-fdeb-72bf-b189-caf9f79f7724.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in your spacious and inviting living room, featuring modern decor, comfortable seating, and abundant natural light. The perfect space to unwind or entertain guests in your new apartment home.",
      "link": "",
      "alt_text": "A brightly lit living room with a light gray sofa, a blue textured armchair, a coffee table, a TV, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec8f99ca-22a2-48bb-b631-26be6be85a65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0070-ffd0-718e-a418-f4df9ac9b01f.webp",
      "image_media": {
        "alt_text": "An apartment dining area with a round table, four upholstered chairs, a large abstract painting, and a sliding glass door.",
        "public_id": "019f0070-ffd0-718e-a418-f4df9ac9b01f",
        "storage_key": "property/6767906449165644/019f0070-ffd0-718e-a418-f4df9ac9b01f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "This spacious apartment dining area features elegant upholstered chairs and a contemporary round table, perfect for intimate meals or entertaining guests. Natural light fills the room through the large patio door.",
      "link": "",
      "alt_text": "An apartment dining area with a round table, four upholstered chairs, a large abstract painting, and a sliding glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_43c2a68f-332d-469f-a3c5-84e1e1067dab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-4583-718d-be77-9098a1c8b3e0.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
        "public_id": "019f0071-4583-718d-be77-9098a1c8b3e0",
        "storage_key": "property/6767906449165644/019f0071-4583-718d-be77-9098a1c8b3e0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Bright and clean apartment bathroom featuring a modern vanity with ample counter space, a toilet, and a white tiled shower/tub combination.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d5230ac4-8267-4224-933b-6742b37f49b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-3f15-754f-b774-cf2475dc88e0.webp",
      "image_media": {
        "alt_text": "Living room with dining table, sofa, and TV.",
        "public_id": "019f0071-3f15-754f-b774-cf2475dc88e0",
        "storage_key": "property/6767906449165644/019f0071-3f15-754f-b774-cf2475dc88e0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a dining table, comfortable sofa, and entertainment center with a TV, perfect for relaxation and gatherings.",
      "link": "",
      "alt_text": "Living room with dining table, sofa, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_968ae577-000c-48bf-adac-47f84c174094",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-29cb-70fd-9e03-f57a991d35d4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white appliances, wood cabinets, and marble countertops.",
        "public_id": "019f0071-29cb-70fd-9e03-f57a991d35d4",
        "storage_key": "property/6767906449165644/019f0071-29cb-70fd-9e03-f57a991d35d4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Explore our spacious kitchens, featuring modern appliances, ample cabinet space, and elegant countertops. Perfect for any home chef!",
      "link": "",
      "alt_text": "Modern kitchen with white appliances, wood cabinets, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_43db1a97-8c13-4d36-91bc-11b73a4b861e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-0baa-748c-baf2-28aab67fd8b4.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with picnic tables and umbrellas.",
        "public_id": "019f0071-0baa-748c-baf2-28aab67fd8b4",
        "storage_key": "property/6767906449165644/019f0071-0baa-748c-baf2-28aab67fd8b4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our community's outdoor grilling stations, perfect for al fresco dining and gathering with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor grilling area with picnic tables and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5bb2ca67-2189-4c08-a686-8b53da4e9c78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0070-fdc9-733a-a522-c65cf71dc218.webp",
      "image_media": {
        "alt_text": "Updated kitchen with white cabinets, white countertops, stainless steel sink, dishwasher, microwave, and white stove.",
        "public_id": "019f0070-fdc9-733a-a522-c65cf71dc218",
        "storage_key": "property/6767906449165644/019f0070-fdc9-733a-a522-c65cf71dc218.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "This updated kitchen features white cabinets, granite countertops, a stainless steel sink, and modern appliances including a microwave, dishwasher, and stove.",
      "link": "",
      "alt_text": "Updated kitchen with white cabinets, white countertops, stainless steel sink, dishwasher, microwave, and white stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b5c1a05a-5c5a-40cf-aedd-9b707ed07ef8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0070-fe69-715a-8990-83707814340a.webp",
      "image_media": {
        "alt_text": "Outdoor BBQ area with picnic tables and grills.",
        "public_id": "019f0070-fe69-715a-8990-83707814340a",
        "storage_key": "property/6767906449165644/019f0070-fe69-715a-8990-83707814340a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy convenient outdoor grilling with our community BBQ area, featuring picnic tables and gas grills perfect for gatherings.",
      "link": "",
      "alt_text": "Outdoor BBQ area with picnic tables and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a55a7f92-f122-4dbf-a76a-46b42b46aea4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-003f-71ba-9573-cbf0b5e72e03.webp",
      "image_media": {
        "alt_text": "View of the community pool area with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f0071-003f-71ba-9573-cbf0b5e72e03",
        "storage_key": "property/6767906449165644/019f0071-003f-71ba-9573-cbf0b5e72e03.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, perfect for relaxing and unwinding on a sunny day. Surrounded by lush landscaping and comfortable seating, it's your oasis.",
      "link": "",
      "alt_text": "View of the community pool area with lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_93e69765-b062-43fc-ac74-3ba3afa92cc1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0070-0278-75d8-8d39-d59f4df189a2.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies, a lush green courtyard, trees, and a winding concrete path under a clear blue sky.",
        "public_id": "019f0070-0278-75d8-8d39-d59f4df189a2",
        "storage_key": "property/6767906449165644/019f0070-0278-75d8-8d39-d59f4df189a2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience the welcoming atmosphere of our community with beautifully landscaped grounds, spacious courtyards, and charming apartment buildings featuring private balconies.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies, a lush green courtyard, trees, and a winding concrete path under a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec8900a4-0be2-4b9d-9135-55bc90fcc15e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0070-6a79-7156-a83c-8a4acacd19ad.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, weight machine, yoga ball, and dumbbells",
        "public_id": "019f0070-6a79-7156-a83c-8a4acacd19ad",
        "storage_key": "property/6767906449165644/019f0070-6a79-7156-a83c-8a4acacd19ad.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our well-equipped fitness center features cardio machines, weight training equipment, and free weights to help you stay active.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical, weight machine, yoga ball, and dumbbells",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c8398e3c-ed71-4f8a-99bc-8e7cac023edf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f006f-aa81-730c-9524-77de079494de.webp",
      "image_media": {
        "alt_text": "Apartment complex outdoor swimming pool and buildings under a clear blue sky.",
        "public_id": "019f006f-aa81-730c-9524-77de079494de",
        "storage_key": "property/6767906449165644/019f006f-aa81-730c-9524-77de079494de.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool at this apartment community. Surrounded by beautiful buildings and lush landscaping, it's the perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Apartment complex outdoor swimming pool and buildings under a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ceef3d9e-c756-4890-906e-50f8856f6ec1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0070-5132-7406-a6e3-1dad3f160ac8.webp",
      "image_media": {
        "alt_text": "Lobby with a fireplace, seating area, and view of the pool.",
        "public_id": "019f0070-5132-7406-a6e3-1dad3f160ac8",
        "storage_key": "property/6767906449165644/019f0070-5132-7406-a6e3-1dad3f160ac8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the spacious and elegant lobby, complete with a cozy fireplace, comfortable seating, and a beautiful view of the outdoor pool.",
      "link": "",
      "alt_text": "Lobby with a fireplace, seating area, and view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63794adc-69e2-4dab-b575-c6309b27ad61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f006f-ab96-7047-a6b7-a14b126b03e9.webp",
      "image_media": {
        "alt_text": "Outdoor community swimming pool with lounge area and apartment buildings in the background.",
        "public_id": "019f006f-ab96-7047-a6b7-a14b126b03e9",
        "storage_key": "property/6767906449165644/019f006f-ab96-7047-a6b7-a14b126b03e9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Dive into relaxation at our sparkling outdoor swimming pool, a central amenity for residents. The expansive pool deck offers plenty of space for lounging and set against the backdrop of our beautiful apartment homes.",
      "link": "",
      "alt_text": "Outdoor community swimming pool with lounge area and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16821847-e3e3-4bd3-a1b2-4583a3e490c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0070-0976-7599-9d09-d0e7ee13310d.webp",
      "image_media": {
        "alt_text": "Path leading through a grassy courtyard with apartment buildings on either side and a picnic area in the background.",
        "public_id": "019f0070-0976-7599-9d09-d0e7ee13310d",
        "storage_key": "property/6767906449165644/019f0070-0976-7599-9d09-d0e7ee13310d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the beautifully maintained courtyards and picnic areas, perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Path leading through a grassy courtyard with apartment buildings on either side and a picnic area in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_55e200bf-d26c-40be-a5eb-3a49c23bed5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f006f-ab98-769b-985c-0784661c44de.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and weight machines.",
        "public_id": "019f006f-ab98-769b-985c-0784661c44de",
        "storage_key": "property/6767906449165644/019f006f-ab98-769b-985c-0784661c44de.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eda5233b-665d-46ff-8c19-6232c58bc470",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f006f-aa70-729b-83e0-8bd0aa8ce41f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a clubhouse in the background.",
        "public_id": "019f006f-aa70-729b-83e0-8bd0aa8ce41f",
        "storage_key": "property/6767906449165644/019f006f-aa70-729b-83e0-8bd0aa8ce41f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and a beautiful clubhouse.",
      "link": "",
      "alt_text": "Outdoor swimming pool with a clubhouse in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1c1442d1-c3bb-4079-b65f-7b4b6295729f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f006f-c044-74a4-9835-b9df0e725a69.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a wooden pergola and apartment buildings in the background.",
        "public_id": "019f006f-c044-74a4-9835-b9df0e725a69",
        "storage_key": "property/6767906449165644/019f006f-c044-74a4-9835-b9df0e725a69.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, complete with a shaded pergola for ultimate relaxation. The surrounding apartment buildings offer a picturesque backdrop.",
      "link": "",
      "alt_text": "Outdoor swimming pool with a wooden pergola and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1af5240d-3bc3-4f4f-9f35-c5163ca217b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f006f-abb5-75ae-a1f7-f59d5ef3d567.webp",
      "image_media": {
        "alt_text": "Winchester monument sign with landscaping",
        "public_id": "019f006f-abb5-75ae-a1f7-f59d5ef3d567",
        "storage_key": "property/6767906449165644/019f006f-abb5-75ae-a1f7-f59d5ef3d567.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Winchester, featuring a beautiful monument sign with manicured landscaping.",
      "link": "",
      "alt_text": "Winchester monument sign with landscaping",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec691622-44fc-4c72-822b-8a23ed8d01cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f006f-aa72-74ee-94a6-82aa1fb5361a.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with picnic tables and umbrellas in front of apartment buildings.",
        "public_id": "019f006f-aa72-74ee-94a6-82aa1fb5361a",
        "storage_key": "property/6767906449165644/019f006f-aa72-74ee-94a6-82aa1fb5361a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our community's outdoor kitchen, complete with grills and picnic tables, perfect for gathering with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor grilling area with picnic tables and umbrellas in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4141dea8-def3-4b97-adaa-c85b402e31f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d47cb-f728-7320-9385-6b4de16edb27.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d47cb-f728-7320-9385-6b4de16edb27",
        "storage_key": "property/6767906449165644/019d47cb-f728-7320-9385-6b4de16edb27.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. The perfect oasis for relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_ba6fa69b-93fc-451f-b4fb-74b5110b71dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2805 I-40, Amarillo, TX 79109, USA",
      "poi_short_description": "Chain steakhouse serving fall-off-the-bone ribs and other American fare in a lively setting.",
      "poi_long_description": "People say this steakhouse serves tender chicken fried steak, delicious ribs, and flavorful ribeye steaks. They highlight the generous portions, reasonable prices, and the legendary rolls with cinnamon butter. They also like the friendly and attentive service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-58cb-757f-831e-ba39826a48ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-58cb-757f-831e-ba39826a48ba",
        "storage_key": "property/6767906449165644/019cfb4d-58cb-757f-831e-ba39826a48ba.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/amarillo?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3328858651283659231&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.1940532",
      "poi_longitude": "-101.8676751",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-352-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-99d96d832275",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQj8GMpPAYcR35k_aU57Mi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_80ebe4c9-8570-43b5-a788-af510c89c3e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Bubba's 33",
      "poi_type": "Restaurants",
      "poi_address": "2813 I-40, Amarillo, TX 79109, USA",
      "poi_short_description": "Laid-back chain serving burgers, beer and pizza, plus sports on multiple TVs.",
      "poi_long_description": "People say this American restaurant serves delicious burgers, pizza, and Philly cheese steaks. They highlight the generous portions, reasonable prices, and lively sports bar atmosphere with numerous TVs. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-580e-724f-99db-a8dfceec0aad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-580e-724f-99db-a8dfceec0aad",
        "storage_key": "property/6767906449165644/019cfb4d-580e-724f-99db-a8dfceec0aad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bubbas33.com/locations/texas/amarillo?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=15317791946731671629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bubbas-33",
      "poi_latitude": "35.1937663",
      "poi_longitude": "-101.8691615",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-353-0033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-99d96d832275",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD99rJspPAYcRTdBHUJ66k9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f9974929-4fe9-4de3-9875-dbe9022c141f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "2323 E Interstate 40 Hwy, Amarillo, TX 79104, USA",
      "poi_short_description": "American chain known for fried chicken, breakfast staples, gift shop and porch rockers.",
      "poi_long_description": "People say this restaurant serves delicious catfish, chicken and dumplings, and meatloaf. They also highlight the quick service, reasonable prices, and attentive staff.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-5894-77ab-86a9-114d1b3e818b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-5894-77ab-86a9-114d1b3e818b",
        "storage_key": "property/6767906449165644/019cfb4d-5894-77ab-86a9-114d1b3e818b.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/tx/amarillo/210/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=13207491288533106944&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "35.1940806",
      "poi_longitude": "-101.8111376",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-372-2034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-99d96d832275",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO_dgNCVPAYcRAAEVw1lvSrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8c139196-a7ac-4d94-8564-1f4102814f63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2525 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Fast-food chain known for its chicken sandwiches and waffle fries, plus breakfast items and a kids' menu.",
      "poi_long_description": "People say this fast food restaurant serves tasty chicken sandwiches, nuggets, and lemonade. They highlight the friendly and attentive staff, and the quick service. They also like the clean atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-58bd-76ef-aa24-f55f5d1a68c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-58bd-76ef-aa24-f55f5d1a68c1",
        "storage_key": "property/6767906449165644/019cfb4d-58bd-76ef-aa24-f55f5d1a68c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/georgia-street?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=9898565818159840665&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.18604200000001",
      "poi_longitude": "-101.8656726",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-358-8055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-99d96d832275",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd_QXe7hPAYcRmb09sSrFXok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_44b7f049-b033-40d4-8874-9d1acd177e24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "2812 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Casual chain eatery specializing in chicken fingers, fries and lemonade.",
      "poi_long_description": "People say this fast food restaurant serves great chicken fingers, and the tailgate trays are good for families. They highlight the fast service and the fresh, hot food. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-5898-748d-8de2-6986862a0523.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-5898-748d-8de2-6986862a0523",
        "storage_key": "property/6767906449165644/019cfb4d-5898-748d-8de2-6986862a0523.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/amarillo/2812-s-georgia-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=905577921826965201&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "35.1828248",
      "poi_longitude": "-101.8668346",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-356-0140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-99d96d832275",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvUy4qoxPAYcR0cbualJCkQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_5d9e66be-4a1b-4a04-9980-cef28c68306d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Westgate Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7701 I-40, Amarillo, TX 79121, USA",
      "poi_short_description": "Spacious shopping hub with familiar retailers and a cinema alongside an arcade and a playground.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and a food court. They also highlight the clean and well-maintained environment.\n\nOther reviews mention it can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-5889-76e7-8a9e-da8580aeff8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-5889-76e7-8a9e-da8580aeff8f",
        "storage_key": "property/6767906449165644/019cfb4d-5889-76e7-8a9e-da8580aeff8f.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "http://www.westgatemalltx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8872045046986861251&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westgate-mall",
      "poi_latitude": "35.184043",
      "poi_longitude": "-101.9280617",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-358-7221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c5a-7684-9d2e-e1a656388a34",
        "storage_key": "property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5aNuwVBQAYcRw2rq0PbVH3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6a5af454-611d-412c-beb6-df1205e54a95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2410 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Sprawling home-improvement chain stocking tools, appliances, lumber, furniture, flooring, paint and plants along with gardening supplies.",
      "poi_long_description": "People say this home improvement store has helpful and knowledgeable staff who are always willing to assist customers in finding the right products and completing their projects. They also highlight the wide selection of home furniture and supplies available at the store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-581d-7208-b2ce-3601f4374288.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-581d-7208-b2ce-3601f4374288",
        "storage_key": "property/6767906449165644/019cfb4d-581d-7208-b2ce-3601f4374288.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/E-Amarillo/TX/Amarillo/79109/6831?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17449643067838617860&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.1887022",
      "poi_longitude": "-101.8687317",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-468-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c5a-7684-9d2e-e1a656388a34",
        "storage_key": "property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_XrzAchPAYcRBNngA-uVKfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_43643a00-8034-451e-a3d4-b3a160a0d354",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "2201 S Western St, Amarillo, TX 79109, USA",
      "poi_short_description": "Chains and department retailer featuring clothing and footwear, plus housewares and gifts.",
      "poi_long_description": "People say this clothing store offers a wide selection of clothing and shoes, including name brands. They also highlight the good prices and quality of the items.\n\nSome reviews mention the layout can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-57d2-7117-b66c-503c7bb244c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-57d2-7117-b66c-503c7bb244c7",
        "storage_key": "property/6767906449165644/019cfb4d-57d2-7117-b66c-503c7bb244c7.webp",
        "width": 488,
        "height": 289
      },
      "poi_business_url": "https://stores.burlington.com/tx/amarillo/564/?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13172599468811409494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "35.1892288",
      "poi_longitude": "-101.8809655",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-353-7087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c5a-7684-9d2e-e1a656388a34",
        "storage_key": "property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQYcDKddPAYcRVtgA62x5zrY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_359a9f8c-46bc-4f54-be53-e5425f782f78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Market Street",
      "poi_type": "Shopping & Retail",
      "poi_address": "2530 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Clean grocery store that’s stocked with national brands alongside local ingredients, and has an on-site bakery and deli.",
      "poi_long_description": "People say this grocery store offers a wide selection of groceries, meats, and ready-to-eat food. They highlight the reasonable prices and clean, well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-580e-724f-99db-acafc9f46cfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-580e-724f-99db-acafc9f46cfa",
        "storage_key": "property/6767906449165644/019cfb4d-580e-724f-99db-acafc9f46cfa.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "https://local.marketstreetunited.com/tx/amarillo/2530-s-georgia-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16028910684191050097&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "market-street",
      "poi_latitude": "35.1862872",
      "poi_longitude": "-101.8681069",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-468-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e9807cca25a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c5a-7684-9d2e-e9807cca25a6",
        "storage_key": "property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e9807cca25a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_27QvMdPAYcRccmrq1chct4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_cbc67ec5-9a8c-4019-ba56-a1123b1cc461",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "3030 S Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Chain selling discounted clothing, accessories and housewares.",
      "poi_long_description": "People say this clothing store offers a wide selection of items. They also highlight the affordable prices and friendly cashiers.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-57d2-7117-b66c-540ea4b8dee2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-57d2-7117-b66c-540ea4b8dee2",
        "storage_key": "property/6767906449165644/019cfb4d-57d2-7117-b66c-540ea4b8dee2.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16582175913080698917&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "35.1797012",
      "poi_longitude": "-101.940193",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-355-8901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c5a-7684-9d2e-e1a656388a34",
        "storage_key": "property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf8ncs_lQAYcRJbg2BiO5H-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_4c482c84-5032-4e76-b6f5-f310f720436c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Amarillo College",
      "poi_type": "Education",
      "poi_address": "2201 S Washington St #2411, Amarillo, TX 79109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-5bde-708a-9d0a-e1117e19af5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-5bde-708a-9d0a-e1117e19af5c",
        "storage_key": "property/6767906449165644/019cfb4d-5bde-708a-9d0a-e1117e19af5c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.actx.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12362103176866188035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-college",
      "poi_latitude": "35.1877711",
      "poi_longitude": "-101.8482546",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-371-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c48-7498-98eb-25f9293415f1",
        "storage_key": "property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhTxRNyhOAYcRA0vWlVcDj6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3c2fb28a-3b1d-4b72-9a52-842481443a38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Amarillo College West Campus",
      "poi_type": "Education",
      "poi_address": "6222 SW 9th Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-5be9-77cc-bfd7-8ffb72e62384.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-5be9-77cc-bfd7-8ffb72e62384",
        "storage_key": "property/6767906449165644/019cfb4d-5be9-77cc-bfd7-8ffb72e62384.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.actx.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7615385847900468607&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-college-west-campus",
      "poi_latitude": "35.2068369",
      "poi_longitude": "-101.9072632",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 806-371-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c48-7498-98eb-25f9293415f1",
        "storage_key": "property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTxkyGsZRAYcRf_WkoxRJr2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e9adec95-fb3b-486d-a88b-6253a93cb803",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Amarillo Zoo",
      "poi_type": "Entertainment",
      "poi_address": "700 Comanchero Trail, Amarillo, TX 79107, USA",
      "poi_short_description": "Small zoo but well-maintained and clean, home to 80+ species including lions and tigers. Friendly staff.",
      "poi_long_description": "Bison & big cats, reptiles, birds & amphibians all can be found in this compact park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-5d16-70d8-a827-dddf2c25378e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-5d16-70d8-a827-dddf2c25378e",
        "storage_key": "property/6767906449165644/019cfb4d-5d16-70d8-a827-dddf2c25378e.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://zoo.amarillo.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7520201244900869847&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-zoo",
      "poi_latitude": "35.2394971",
      "poi_longitude": "-101.8352622",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-381-7911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy-PYbYVOAYcR10bEQTAfXWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_a73938a3-d0b7-4476-9065-3044cd0edffe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Wonderland Amusement Park",
      "poi_type": "Entertainment",
      "poi_address": "2601 Dumas Dr, Amarillo, TX 79107, USA",
      "poi_short_description": "Amusement park featuring 30+ rides plus roller coasters, a Ferris wheel and a dark ride.",
      "poi_long_description": "People say this amusement park offers amazing rides for kids and a nostalgic experience with classic rides. They also highlight the friendly and helpful staff, and the safe and clean atmosphere.\n\nOther reviews mention the rides can be unavailable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-5cc1-732e-b248-fbd966338397.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-5cc1-732e-b248-fbd966338397",
        "storage_key": "property/6767906449165644/019cfb4d-5cc1-732e-b248-fbd966338397.webp",
        "width": 1280,
        "height": 614
      },
      "poi_business_url": "http://www.wonderlandpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8243954437591312918&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wonderland-amusement-park",
      "poi_latitude": "35.2407215",
      "poi_longitude": "-101.8321242",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-383-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdfEzUZtOAYcRFqoi9eFoaHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_765b44ab-97ec-4b5c-863b-73c84816b85d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Hodgetown Stadium",
      "poi_type": "Entertainment",
      "poi_address": "715 S Buchanan St, Amarillo, TX 79101, USA",
      "poi_short_description": "Baseball stadium with fireworks, Star Wars theme nights, and other promotions, plus food and a restroom.",
      "poi_long_description": "Fans say this stadium offers a fun, family-friendly atmosphere with exciting baseball games, delicious food, and spectacular fireworks shows. They also highlight the friendly and helpful staff, and the overall enjoyable experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-5d25-76d8-abb0-113989bf3757.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-5d25-76d8-abb0-113989bf3757",
        "storage_key": "property/6767906449165644/019cfb4d-5d25-76d8-abb0-113989bf3757.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.milb.com/amarillo/tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=7306300840172905774&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hodgetown-stadium",
      "poi_latitude": "35.205011",
      "poi_longitude": "-101.8317304",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-803-7762",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c5e-7213-9045-9b28a1178109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c5e-7213-9045-9b28a1178109",
        "storage_key": "property/6767906449165644/019cfb4d-6c5e-7213-9045-9b28a1178109.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTRhSe6dPAYcRLuWkWOcxZWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_1ff8cc34-965b-4b85-bebf-8f09ca18153f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Dick Bivins Stadium",
      "poi_type": "Entertainment",
      "poi_address": "801 S Marrs St, Amarillo, TX 79104, USA",
      "poi_short_description": "Dated stadium and field for high-school football and other sporting events, featuring a track.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-5d6e-7458-b414-3d9baea9cb89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-5d6e-7458-b414-3d9baea9cb89",
        "storage_key": "property/6767906449165644/019cfb4d-5d6e-7458-b414-3d9baea9cb89.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6165663888283590691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dick-bivins-stadium",
      "poi_latitude": "35.2030245",
      "poi_longitude": "-101.8009337",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 806-326-1102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c5e-7213-9045-9b28a1178109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c5e-7213-9045-9b28a1178109",
        "storage_key": "property/6767906449165644/019cfb4d-6c5e-7213-9045-9b28a1178109.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw8PLqitPAYcRI-CYqaPWkFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_5094c9c5-cabe-49f5-a259-fd1c5bac4a19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Don Harrington Discovery Center",
      "poi_type": "Entertainment",
      "poi_address": "1200 Streit Dr, Amarillo, TX 79106, USA",
      "poi_short_description": "Children's venue offering exhibits and a theater showcasing space shows and other films.",
      "poi_long_description": "Permanent exhibits on the universe & weather, plus a theater & visiting shows for toddlers to teens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-5d1e-775c-969c-23d2f753a010.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-5d1e-775c-969c-23d2f753a010",
        "storage_key": "property/6767906449165644/019cfb4d-5d1e-775c-969c-23d2f753a010.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://discoverycenteramarillo.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=551b89ca-129c-4559-8dfb-452b2909f411",
      "poi_directions_map_url": "https://maps.google.com/?cid=13217897852746957318&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "don-harrington-discovery-center",
      "poi_latitude": "35.2000385",
      "poi_longitude": "-101.9132754",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-355-9547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c54-749c-9501-0b2e08b13f41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c54-749c-9501-0b2e08b13f41",
        "storage_key": "property/6767906449165644/019cfb4d-6c54-749c-9501-0b2e08b13f41.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJtwVFCrZRAYcRBoJhzhBob7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4585b273-5540-49c6-94af-73a50b0c5923",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3801 Olsen Blvd, Amarillo, TX 79109, USA",
      "poi_short_description": "Clean 24/7 gym featuring treadmills, plus massage chairs and tanning beds.",
      "poi_long_description": "People say this gym is clean and not overly crowded. They also highlight the friendly staff and the recent remodel.\n\nOther reviews mention the changing areas can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-5d35-7049-947f-f938b5a7b0a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-5d35-7049-947f-f938b5a7b0a1",
        "storage_key": "property/6767906449165644/019cfb4d-5d35-7049-947f-f938b5a7b0a1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/amarillo-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1977894688478342336&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.1847141",
      "poi_longitude": "-101.8828415",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 806-358-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyaJ0MNpPAYcRwCziZb3kchs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fc4ce03c-f033-4c0d-86c4-9978e9a8d702",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Crunch Fitness - Amarillo",
      "poi_type": "Health and Wellness",
      "poi_address": "2020 S Georgia St, Amarillo, TX 79109, USA",
      "poi_short_description": "Chain fitness center offering group classes and personal training, plus tanning and a daycare.",
      "poi_long_description": "People say this gym offers a wide selection of equipment, including assisted weights, free weights, and plate-loaded machines. They also highlight the friendly and helpful staff, and the clean facilities.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-5e97-713a-9575-65ed4f578ada.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-5e97-713a-9575-65ed4f578ada",
        "storage_key": "property/6767906449165644/019cfb4d-5e97-713a-9575-65ed4f578ada.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/amarillo",
      "poi_directions_map_url": "https://maps.google.com/?cid=5337674825006290011&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---amarillo",
      "poi_latitude": "35.1919693",
      "poi_longitude": "-101.867029",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-358-0706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ429cxMlPAYcRW5QLH_k6E0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_43b8f725-fa8a-42ba-80fa-2376e34616aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "TruFit Athletic Clubs - I40/Bell St.",
      "poi_type": "Health and Wellness",
      "poi_address": "2200 Bell St, Amarillo, TX 79106, USA",
      "poi_short_description": "Gym chain featuring premium facilities such as basketball courts and saunas, plus personal trainers.",
      "poi_long_description": "Gym goers say this gym has a wide variety of equipment, including free weights, pin machines, plate loaded machines, smith machines, and treadmills, as well as a women’s only area and a sauna. They also highlight the friendly and helpful staff, the clean environment, and the spacious layout.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-5e51-7528-9b96-0d2bef9389b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-5e51-7528-9b96-0d2bef9389b8",
        "storage_key": "property/6767906449165644/019cfb4d-5e51-7528-9b96-0d2bef9389b8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://trufitathleticclubs.com/gym-near-me/tru-fit-texas/amarillo/hwy-40-bell-st/&utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17282652066854458207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trufit-athletic-clubs---i40bell-st",
      "poi_latitude": "35.1889247",
      "poi_longitude": "-101.9037135",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-803-2302",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUXZW6JRAYcRX9OHxXxQ2O8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_14525edf-2c99-4043-80bd-e9c35b9a8e66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "2814 S Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Large chain selling cosmetics, skincare and fragrance, plus hair salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6097-7194-b2d1-5795d65d349c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6097-7194-b2d1-5795d65d349c",
        "storage_key": "property/6767906449165644/019cfb4d-6097-7194-b2d1-5795d65d349c.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/amarillo-tx-278",
      "poi_directions_map_url": "https://maps.google.com/?cid=6046894659973430930&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.1814406",
      "poi_longitude": "-101.9399397",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-355-1176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8ncs_lQAYcRkj7syafi6lM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_1b7745f7-816a-458d-b355-2dceba9d9506",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Amarillo Town Club",
      "poi_type": "Health and Wellness",
      "poi_address": "5801, 4514 Cornell St A, Amarillo, TX 79109, USA",
      "poi_short_description": "Health club offering a variety of equipment and classes, along with indoor and outdoor pools.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-61b1-7494-b3da-f8df71ea26a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-61b1-7494-b3da-f8df71ea26a6",
        "storage_key": "property/6767906449165644/019cfb4d-61b1-7494-b3da-f8df71ea26a6.webp",
        "width": 1200,
        "height": 688
      },
      "poi_business_url": "https://amarillotownclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16997861687070698109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-town-club",
      "poi_latitude": "35.16022100000001",
      "poi_longitude": "-101.89843",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-468-0398",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjT76sAVQAYcRfSoSVyWJ5Os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_004b3892-0b70-473a-a8f0-495d7e0d5566",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "P.E.T.S. Clinic of Amarillo",
      "poi_type": "Health and Wellness",
      "poi_address": "2500 SW 6th Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6388-75e6-9636-83148730a42b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6388-75e6-9636-83148730a42b",
        "storage_key": "property/6767906449165644/019cfb4d-6388-75e6-9636-83148730a42b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.petsclinic.org/locations/amarillo-texas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1242055613026336119&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pets-clinic-of-amarillo",
      "poi_latitude": "35.2117343",
      "poi_longitude": "-101.8647921",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 806-680-7049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJyRWFUtPAYcRd_221f-qPBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_de32c3e9-6e83-4d4c-acc1-631c3c455dc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Bnails Amarillo ( Voted Best Nail Salon Amarillo TX)",
      "poi_type": "Health and Wellness",
      "poi_address": "5901 Coulter St S #200, Amarillo, TX 79119, USA",
      "poi_short_description": "Modern nail salon offering a variety of treatments including pedicures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-621e-7349-931e-7bf9c80ad37b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-621e-7349-931e-7bf9c80ad37b",
        "storage_key": "property/6767906449165644/019cfb4d-621e-7349-931e-7bf9c80ad37b.webp",
        "width": 1050,
        "height": 1050
      },
      "poi_business_url": "https://bnails.com/locations/bnails-amarillo",
      "poi_directions_map_url": "https://maps.google.com/?cid=2463208448936350150&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bnails-amarillo--voted-best-nail-salon-amarillo-tx",
      "poi_latitude": "35.1476278",
      "poi_longitude": "-101.9194274",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-329-0101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkbhOxQdbAYcRxpGXnggTLyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_720233c4-9196-4c2f-b231-e3088c6c3abe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "The Gym @ Contagion Athletics",
      "poi_type": "Health and Wellness",
      "poi_address": "8210 W Amarillo Blvd Suite A, Amarillo, TX 79124, USA",
      "poi_short_description": "Clean gym with modern equipment, turf, private rooms, a cafe, and friendly staff.",
      "poi_long_description": "People say this gym offers a wide variety of high-quality equipment, including machines, free weights, and power racks, as well as a track and field. They highlight the spacious layout, motivating atmosphere, and clean facilities. They also like the friendly, supportive, and accommodating staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-62fd-719e-8b5b-f00e2f71de8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-62fd-719e-8b5b-f00e2f71de8b",
        "storage_key": "property/6767906449165644/019cfb4d-62fd-719e-8b5b-f00e2f71de8b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://contagionathletics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1028127880143985371&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-gym--contagion-athletics",
      "poi_latitude": "35.1921768",
      "poi_longitude": "-101.9283828",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 806-599-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVPdCchaAYcR21qoF9ykRA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_045f1943-1ecf-429c-b86a-400aaa7d9122",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4514 First United Dr, Amarillo, TX 79119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-62b1-7129-aaac-0af2b9802745.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-62b1-7129-aaac-0af2b9802745",
        "storage_key": "property/6767906449165644/019cfb4d-62b1-7129-aaac-0af2b9802745.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/amarillo-texas-4451/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4451",
      "poi_directions_map_url": "https://maps.google.com/?cid=4329623978590993559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "35.1605005",
      "poi_longitude": "-101.9368164",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-367-9842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkwTg_UNRAYcRl_ztthHqFTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_258c89d4-566c-4f07-ac7e-0442381de6ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Small Animal Emergency Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "5127 Canyon Dr, Amarillo, TX 79110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-62ae-71b8-b1b9-dd3708218394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-62ae-71b8-b1b9-dd3708218394",
        "storage_key": "property/6767906449165644/019cfb4d-62ae-71b8-b1b9-dd3708218394.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.smallanimalec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3409723369463033888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "small-animal-emergency-clinic",
      "poi_latitude": "35.156026",
      "poi_longitude": "-101.877585",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 806-352-2277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQR8CU5FAYcRIDAxy1bFUS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_eca11957-d3ce-46fd-a62d-9da3e9addfe5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "BSA Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1600 Wallace Blvd, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6398-76bf-b394-029637ce5ef0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6398-76bf-b394-029637ce5ef0",
        "storage_key": "property/6767906449165644/019cfb4d-6398-76bf-b394-029637ce5ef0.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://bsahs.org/find-a-provider/location/entity69860/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8155463932870903813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bsa-hospital",
      "poi_latitude": "35.19633",
      "poi_longitude": "-101.9203683",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 806-212-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-96f66dc06368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-96f66dc06368",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-96f66dc06368.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-hXBuxRAYcRBchHyTwHLnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bb0e9514-abe9-4bcb-81b5-239424b3571a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Northwest Texas Healthcare System",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 Coulter St, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6386-75bb-9e5e-0ed4729b16fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6386-75bb-9e5e-0ed4729b16fa",
        "storage_key": "property/6767906449165644/019cfb4d-6386-75bb-9e5e-0ed4729b16fa.webp",
        "width": 724,
        "height": 407
      },
      "poi_business_url": "https://www.nwths.com/?utm_source=Google-Business-Yext&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=2075520162708353978&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northwest-texas-healthcare-system",
      "poi_latitude": "35.1998268",
      "poi_longitude": "-101.9201891",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 806-354-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-96f66dc06368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-96f66dc06368",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-96f66dc06368.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO08CY7FRAYcRunNkZpe6zRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bb45b1f3-34ee-4e3b-8a41-56aa5c4d4515",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Amarillo Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1400 Streit Dr, Amarillo, TX 79106, USA",
      "poi_short_description": "Small but well-maintained botanical garden featuring a Japanese area, a conservatory and a rose garden.",
      "poi_long_description": "People say this botanical garden offers a beautiful variety of plants, flowers, and themed gardens, including a butterfly garden, desert garden, rose garden, and Japanese garden. They highlight the peaceful and relaxing atmosphere, perfect for enjoying nature and taking photos, and the well-maintained grounds with easy-to-navigate walking paths. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-63c4-72e5-bd9e-226e5a2770f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-63c4-72e5-bd9e-226e5a2770f7",
        "storage_key": "property/6767906449165644/019cfb4d-63c4-72e5-bd9e-226e5a2770f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.amarillobotanicalgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11051265959285629208&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-botanical-gardens",
      "poi_latitude": "35.197691",
      "poi_longitude": "-101.915258",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-352-6513",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c40-723c-a06d-0ef744933b7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c40-723c-a06d-0ef744933b7b",
        "storage_key": "property/6767906449165644/019cfb4d-6c40-723c-a06d-0ef744933b7b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYUtV7RRAYcRGCGWfdb7XZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_830fe66d-e79c-4368-8bfe-8a67ffc27181",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "John Stiff Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4800 Bell St, Amarillo, TX 79109, USA",
      "poi_short_description": "Large open space, mainly for organized sports, featuring soccer and baseball fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6523-77f8-8bfa-4e6169318a66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6523-77f8-8bfa-4e6169318a66",
        "storage_key": "property/6767906449165644/019cfb4d-6523-77f8-8bfa-4e6169318a66.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amarilloparks.org/parks-facilities/parks/john-stiff-memorial-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14142316035318156834&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "john-stiff-memorial-park",
      "poi_latitude": "35.1534565",
      "poi_longitude": "-101.9061596",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-378-3036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c40-723c-a06d-0ef744933b7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c40-723c-a06d-0ef744933b7b",
        "storage_key": "property/6767906449165644/019cfb4d-6c40-723c-a06d-0ef744933b7b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ5FNyghQAYcRIg5zQoGZQ8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9baea756-e508-41fb-a866-f55bf428a835",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Ross Rogers Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "722 NW 24th Ave, Amarillo, TX 79107, USA",
      "poi_short_description": "Golf course featuring 36 holes, a snack bar, and golf carts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6610-722a-ab51-365dfda1d1f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6610-722a-ab51-365dfda1d1f2",
        "storage_key": "property/6767906449165644/019cfb4d-6610-722a-ab51-365dfda1d1f2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.playgolfamarillo.com/ross-rogers",
      "poi_directions_map_url": "https://maps.google.com/?cid=1629518083161673529&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-rogers-golf-course",
      "poi_latitude": "35.2392538",
      "poi_longitude": "-101.842932",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-378-3086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e75e4c4d7ced.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c5a-7684-9d2e-e75e4c4d7ced",
        "storage_key": "property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e75e4c4d7ced.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJMXHQDIBOAYcROU_tJRA2nRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_5d3782c6-1c47-45f6-84e7-a51e6aced7d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Thompson Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2401 Dumas Dr, Amarillo, TX 79107, USA",
      "poi_short_description": "Green space offering disc golf and picnicking, plus a playground, volleyball, and a dog park.",
      "poi_long_description": "Urban green space offering a disc-golf course, a dog park, picnic areas & a children's playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-66dc-760a-b007-8d9a86b40f57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-66dc-760a-b007-8d9a86b40f57",
        "storage_key": "property/6767906449165644/019cfb4d-66dc-760a-b007-8d9a86b40f57.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amarilloparks.org/parks-facilities/parks/thompson-memorial-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1873064284179257109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thompson-memorial-park",
      "poi_latitude": "35.2377131",
      "poi_longitude": "-101.8350602",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 806-378-3036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c40-723c-a06d-0ef744933b7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c40-723c-a06d-0ef744933b7b",
        "storage_key": "property/6767906449165644/019cfb4d-6c40-723c-a06d-0ef744933b7b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ14wDWoROAYcRFdf54wp2_hk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cc1a2ff5-c7df-4187-93a5-79d3f2eaa9a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Wildcat Bluff Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2301 N Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Preserve with miles of hiking trails and historical exhibits including a dig pit, plus picnic areas.",
      "poi_long_description": "Visitors say this nature preserve offers several easy hiking trails, a large playground, and a wildlife center with local animals. They also highlight the beautiful wildflowers, diverse terrain, and well-maintained trails, making it a great spot for families with kids and grandparents.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-67e0-70ba-a66f-fbe7500236c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-67e0-70ba-a66f-fbe7500236c8",
        "storage_key": "property/6767906449165644/019cfb4d-67e0-70ba-a66f-fbe7500236c8.webp",
        "width": 1125,
        "height": 633
      },
      "poi_business_url": "http://wildcatbluff.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=ff955b2f-0847-4125-bf3c-98fd107de872",
      "poi_directions_map_url": "https://maps.google.com/?cid=1448519830726704444&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wildcat-bluff-nature-center",
      "poi_latitude": "35.2351151",
      "poi_longitude": "-101.9398872",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-352-6007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c40-723c-a06d-0ef744933b7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c40-723c-a06d-0ef744933b7b",
        "storage_key": "property/6767906449165644/019cfb4d-6c40-723c-a06d-0ef744933b7b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnY_PHH5RAYcRPP2SiBwtGhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fa74e5f1-6d2c-4fbe-98e3-f39209f49800",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Tradewind Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4105 Tradewind St, Amarillo, TX 79118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-67cf-718b-90fe-083a937766a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-67cf-718b-90fe-083a937766a2",
        "storage_key": "property/6767906449165644/019cfb4d-67cf-718b-90fe-083a937766a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tradewindairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15990282243124226512&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tradewind-airport",
      "poi_latitude": "35.168991",
      "poi_longitude": "-101.828453",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-376-1008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6f4b-71b8-a69d-79a5812b6e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6f4b-71b8-a69d-79a5812b6e89",
        "storage_key": "property/6767906449165644/019cfb4d-6f4b-71b8-a69d-79a5812b6e89.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yXpyPFOAYcR0Omn3_rk6N0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_1ced4aaf-2dfd-4d45-9098-7e033d81a1e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Amarillo City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "623 S Johnson St, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-67ce-72a3-90f6-a9d66e252660.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-67ce-72a3-90f6-a9d66e252660",
        "storage_key": "property/6767906449165644/019cfb4d-67ce-72a3-90f6-a9d66e252660.webp",
        "width": 1280,
        "height": 867
      },
      "poi_business_url": "https://www.amarillo.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17223577524634485538&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amarillo-city-hall",
      "poi_latitude": "35.2061862",
      "poi_longitude": "-101.8291358",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-378-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6f54-74be-8ffa-46f7a1477d59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6f54-74be-8ffa-46f7a1477d59",
        "storage_key": "property/6767906449165644/019cfb4d-6f54-74be-8ffa-46f7a1477d59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGW0sOONOAYcRIoM9FYFwBu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_8046a47b-b80d-4ef1-9794-5bf85899bee1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Panhandle Eye Group Corporate Business Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7400 Fleming Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-67a8-7739-bb3a-41b4467bf0fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-67a8-7739-bb3a-41b4467bf0fe",
        "storage_key": "property/6767906449165644/019cfb4d-67a8-7739-bb3a-41b4467bf0fe.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.paneye.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6239967148491259387&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "panhandle-eye-group-corporate-business-office",
      "poi_latitude": "35.1935734",
      "poi_longitude": "-101.9237593",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 806-331-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKcUlU61RAYcR-73tjw_RmFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6b6e52da-2ae3-41e4-95a7-5ff468ee08cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Toot'n Totum Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 S Taylor St, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tootntotum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9938605481419247298&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tootn-totum-corporate-office",
      "poi_latitude": "35.2019996",
      "poi_longitude": "-101.8364486",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-373-4351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyWigFwJPAYcRwo6-QgcF7Yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2b064a7f-f3b3-46fb-9358-bc9224494ada",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Downtown Women's Center - Admin Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "409 S Monroe St, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.dwcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17471674227271005040&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "downtown-womens-center---admin-office",
      "poi_latitude": "35.2100297",
      "poi_longitude": "-101.8426996",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-372-3625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-D7mlVOAYcRcPPVCyTbd_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_79dd28a7-d1be-4a7f-b7e5-d77cb5236e82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Panhandle AIDS Support Organization",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1501 SW 10th Ave, Amarillo, TX 79101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-682f-74bd-a8a9-021e86d1cfd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-682f-74bd-a8a9-021e86d1cfd7",
        "storage_key": "property/6767906449165644/019cfb4d-682f-74bd-a8a9-021e86d1cfd7.webp",
        "width": 1280,
        "height": 892
      },
      "poi_business_url": "http://panhandleaso.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7593567755602905026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "panhandle-aids-support-organization",
      "poi_latitude": "35.2048277",
      "poi_longitude": "-101.8548318",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-372-1050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcxRxZalPAYcRwkeSKqTFYWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_afb4dee5-808e-46b7-9045-b339d26aee9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "West Texas A & M UNIVERSITY",
      "poi_type": "Education",
      "poi_address": "1701 N 23rd St, Canyon, TX 79015, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9524884017220202867&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "west-texas-a-m-university",
      "poi_latitude": "34.9983857",
      "poi_longitude": "-101.9221698",
      "poi_miles_from_property": "15.1 mi",
      "poi_walking_minutes": "5 hours 31 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c48-7498-98eb-25f9293415f1",
        "storage_key": "property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsysfS21dAYcRc7E0dYwvL4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_990793c2-6aeb-44f8-ad9a-698aef8f24df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Avondale Elementary School",
      "poi_type": "Education",
      "poi_address": "1500 S Avondale St, Amarillo, TX 79106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-c1e1-7549-9662-49956109cdda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c1e1-7549-9662-49956109cdda",
        "storage_key": "property/6767906449165644/019d7913-c1e1-7549-9662-49956109cdda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://avondale.amaisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8097284777467163702&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "avondale-elementary-school",
      "poi_latitude": "35.1991085",
      "poi_longitude": "-101.8939944",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 806-326-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c48-7498-98eb-25f9293415f1",
        "storage_key": "property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmTEIh9RRAYcRNrQblppVX3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7c51cc00-6236-472a-a349-fe5784c711a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Sam Houston Junior High School",
      "poi_type": "Education",
      "poi_address": "Amarillo, TX 79106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-c211-723d-b57b-d9328dad2106.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c211-723d-b57b-d9328dad2106",
        "storage_key": "property/6767906449165644/019d7913-c211-723d-b57b-d9328dad2106.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://houston.amaisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4091524217471597151&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-houston-junior-high-school",
      "poi_latitude": "35.2081278",
      "poi_longitude": "-101.8823107",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-326-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c48-7498-98eb-25f9293415f1",
        "storage_key": "property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-9-XXS9OAYcRX3pNFJkDyDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ca51b984-4c53-4393-8039-f9849e60c978",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Tascosa High School",
      "poi_type": "Education",
      "poi_address": "3921 Westlawn Ave, Amarillo, TX 79102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-c105-75de-bd19-18869b98c922.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c105-75de-bd19-18869b98c922",
        "storage_key": "property/6767906449165644/019d7913-c105-75de-bd19-18869b98c922.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ths.amaisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8082803395673146233&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tascosa-high-school",
      "poi_latitude": "35.1936673",
      "poi_longitude": "-101.8804395",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-326-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c48-7498-98eb-25f9293415f1",
        "storage_key": "property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC69AFdJPAYcReUNrJN3iK3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ca04614a-30a1-4e0b-b556-a6f8bd6cae8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Vista College Amarillo",
      "poi_type": "Education",
      "poi_address": "3440 Bell St # 230, Amarillo, TX 79109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-c4f3-72ac-8dff-f5a1229295fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c4f3-72ac-8dff-f5a1229295fd",
        "storage_key": "property/6767906449165644/019d7913-c4f3-72ac-8dff-f5a1229295fd.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4570450915323842204&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "vista-college-amarillo",
      "poi_latitude": "35.1748151",
      "poi_longitude": "-101.9040695",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-553-2255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c48-7498-98eb-25f9293415f1",
        "storage_key": "property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkRv_Dz1QAYcRnI48Z-SAbT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_40a26d15-fb98-4e4c-8f71-7332e6529529",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Wayland Baptist University - Amarillo",
      "poi_type": "Education",
      "poi_address": "4530 Canyon Dr, Amarillo, TX 79109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-c950-761b-8050-74d57c888aa1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c950-761b-8050-74d57c888aa1",
        "storage_key": "property/6767906449165644/019d7913-c950-761b-8050-74d57c888aa1.webp",
        "width": 1024,
        "height": 681
      },
      "poi_business_url": "https://www.wbu.edu/campuses/amarillo/?utm_source=gmb&utm_medium=listingamarillo&utm_campaign=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=15959616753557496194&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wayland-baptist-university-amarillo",
      "poi_latitude": "35.162446",
      "poi_longitude": "-101.874484",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-352-5207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c48-7498-98eb-25f9293415f1",
        "storage_key": "property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1-8ky0NPAYcRguEqM-Hye90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b6415fab-965e-4438-90ec-29af509a8563",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Carver ECA Elementary School",
      "poi_type": "Education",
      "poi_address": "1800 N Travis St, Amarillo, TX 79107, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-c9f0-70cf-941c-bb1e76d44ad7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c9f0-70cf-941c-bb1e76d44ad7",
        "storage_key": "property/6767906449165644/019d7913-c9f0-70cf-941c-bb1e76d44ad7.webp",
        "width": 984,
        "height": 877
      },
      "poi_business_url": "https://gwceca.amaisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5838131894708729005&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "carver-eca-elementary-school",
      "poi_latitude": "35.2328015",
      "poi_longitude": "-101.852703",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 806-326-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c48-7498-98eb-25f9293415f1",
        "storage_key": "property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP56PLGVOAYcRrfT9xwY2BVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_0d551a72-0291-4b25-a3a8-990a2db52349",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Houston Middle School",
      "poi_type": "Education",
      "poi_address": "815 S Independence St, Amarillo, TX 79106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-ce7c-7520-86a7-feb94d3669d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ce7c-7520-86a7-feb94d3669d4",
        "storage_key": "property/6767906449165644/019d7913-ce7c-7520-86a7-feb94d3669d4.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://houston.amaisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10091397598678624448&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "houston-middle-school",
      "poi_latitude": "35.2083292",
      "poi_longitude": "-101.8825675",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-326-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c48-7498-98eb-25f9293415f1",
        "storage_key": "property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ56CGVy9OAYcRwCh4RKbYC4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a084c162-69d6-48c7-a9c5-ec381297ddad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Caprock High School",
      "poi_type": "Education",
      "poi_address": "3001 E 34th Ave, Amarillo, TX 79103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-cd74-76f6-a596-7a0a88776490.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-cd74-76f6-a596-7a0a88776490",
        "storage_key": "property/6767906449165644/019d7913-cd74-76f6-a596-7a0a88776490.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://chs.amaisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17239008733817650525&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "caprock-high-school",
      "poi_latitude": "35.179847",
      "poi_longitude": "-101.802055",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 806-326-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c48-7498-98eb-25f9293415f1",
        "storage_key": "property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqXudlUtPAYcRXb0OcxtDPe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f393146f-c9b2-4bba-92c0-fc35fc3cb243",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Applebee's Grill + Bar",
      "poi_type": "Restaurants",
      "poi_address": "2810 Soncy Rd, Amarillo, TX 79121, USA",
      "poi_short_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_long_description": "People say this restaurant offers a variety of dishes and some find the prices reasonable.\n\nOther reviews mention the service can be slow and the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-d03d-752d-9d5e-4d561d4cda2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d03d-752d-9d5e-4d561d4cda2a",
        "storage_key": "property/6767906449165644/019d7913-d03d-752d-9d5e-4d561d4cda2a.webp",
        "width": 1280,
        "height": 583
      },
      "poi_business_url": "https://restaurants.applebees.com/en-us/tx/amarillo/2810-soncy-road-89077?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=89077&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=2981607637880028169&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "applebee-s-grill-bar",
      "poi_latitude": "35.1817193",
      "poi_longitude": "-101.9387782",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-351-2810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-99d96d832275",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4fpx3PlQAYcRCTxuc1nMYCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ce945410-b3ed-49f1-ad5b-603cab466210",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Dyer's Bar-B-Que",
      "poi_type": "Restaurants",
      "poi_address": "1619 S Kentucky St E #526, Amarillo, TX 79102, USA",
      "poi_short_description": "Hickory-smoked classics like brisket & ribs are served at this saloon-style BBQ spot.",
      "poi_long_description": "People say this barbecue restaurant serves delicious ribs, brisket, pulled pork, and smoked turkey. They also highlight the generous portions, reasonable prices, and friendly service.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-d196-74c7-94b1-4b7978bfe063.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d196-74c7-94b1-4b7978bfe063",
        "storage_key": "property/6767906449165644/019d7913-d196-74c7-94b1-4b7978bfe063.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.dyersbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18315384794860671710&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dyer-s-bar-b-que",
      "poi_latitude": "35.1970311",
      "poi_longitude": "-101.8670973",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-358-7104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-99d96d832275",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIduWActPAYcR3tJCjm5RLf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_af7ba894-07de-4ecb-9a8b-201ed84a4f23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "The Big Texan Steak Ranch & Brewery",
      "poi_type": "Restaurants",
      "poi_address": "7701 I-40, Amarillo, TX 79118, USA",
      "poi_short_description": "Kitschy, saloon-style steakhouse known for its 72-oz steak-eating challenge, plus a gift shop.",
      "poi_long_description": "Diners say this steak house serves up delicious chicken fried steak, prime rib, and ribeye, with many enjoying the fried mushrooms and carrot cake. They also highlight the fun and lively atmosphere, especially the 72oz steak challenge, and the friendly and attentive service.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-d585-759b-be98-9ce00252cd53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d585-759b-be98-9ce00252cd53",
        "storage_key": "property/6767906449165644/019d7913-d585-759b-be98-9ce00252cd53.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://bigtexan.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5117666892488480788&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-big-texan-steak-ranch-brewery",
      "poi_latitude": "35.1936085",
      "poi_longitude": "-101.7548896",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 806-372-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-99d96d832275",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3RIOIl9IAYcRFJiNleyaBUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_f9806f3f-8e68-483f-9ec9-20b54d5a0c14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4121 I-40, Amarillo, TX 79109, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "People say this Italian restaurant serves delicious appetizers, fresh salads, and tasty entrees like meat manicotti and chicken parmigiana. They also highlight the reasonable prices, generous portions, and the attentive and friendly service provided by the staff.\n\nOther reviews mention the wait can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-d96b-756b-a9df-36777aea2ff4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d96b-756b-a9df-36777aea2ff4",
        "storage_key": "property/6767906449165644/019d7913-d96b-756b-a9df-36777aea2ff4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.olivegarden.com/locations/tx/amarillo/amarillo/1130?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:amarillo-tx-1130_pl:locurl_rd:1085",
      "poi_directions_map_url": "https://maps.google.com/?cid=16625068130006294055&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "35.190743",
      "poi_longitude": "-101.88343",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 806-355-9973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-99d96d832275",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuRexNdFPAYcRJ16xf2EbuOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_a680fdc8-9b02-4b1f-9b90-306b2359a324",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Crush Wine Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "627 S Polk St, Amarillo, TX 79101, USA",
      "poi_short_description": "Intimate bar with a wine room and tap beer serving New American fare in a contemporary atmosphere.",
      "poi_long_description": "People say this restaurant serves delicious ribeye steak, chicken and waffles, and guacamole toast. They also highlight the friendly and attentive service, and the stylish yet comfortable atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-dfbd-71ec-8cb9-d69dd1d385ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-dfbd-71ec-8cb9-d69dd1d385ac",
        "storage_key": "property/6767906449165644/019d7913-dfbd-71ec-8cb9-d69dd1d385ac.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://crushamarillo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17783013990137984411&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crush-wine-bar-grill",
      "poi_latitude": "35.2067373",
      "poi_longitude": "-101.8369805",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-418-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-99d96d832275",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLx_fGfxOAYcRm_X5bQH1yfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_0db9c3bf-f4cf-4b1b-9667-20905a222991",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Six Car Pub & Brewery",
      "poi_type": "Restaurants",
      "poi_address": "625 S Polk St, Amarillo, TX 79101, USA",
      "poi_short_description": "Hip, modern microbrewery & restaurant offering craft beers, American pub fare & a roof deck.",
      "poi_long_description": "People say this brewpub offers delicious craft beer, including a prickly pear cider, and tasty food, such as cheese curds, burgers, and grilled cheese. They also highlight the chill atmosphere, especially on the outdoor patio, and the kind and attentive service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-e031-77e1-91c0-6fb6b3a44a5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e031-77e1-91c0-6fb6b3a44a5f",
        "storage_key": "property/6767906449165644/019d7913-e031-77e1-91c0-6fb6b3a44a5f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sixcarpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14826443887571770568&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "six-car-pub-brewery",
      "poi_latitude": "35.2068861",
      "poi_longitude": "-101.8369139",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-576-3396",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7914-0c6e-73e4-b303-54bdbf2fc04f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7914-0c6e-73e4-b303-54bdbf2fc04f",
        "storage_key": "property/6767906449165644/019d7914-0c6e-73e4-b303-54bdbf2fc04f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgTz-D_xOAYcRyBz6cCkcws0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_06f201ca-8ebf-4313-b8dc-357305bde487",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Yellow City Street Food - YCSF",
      "poi_type": "Restaurants",
      "poi_address": "2916 Wolflin Ave, Amarillo, TX 79109, USA",
      "poi_short_description": "Chill counter-serve eatery serving burgers & other seasonal, made-to-order bites, plus craft beers.",
      "poi_long_description": "People say this restaurant serves delicious tacos, burgers, and animal fries, with a variety of vegan options. They highlight the creative and flavorful daily specials, and the extensive craft beer selection. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-e0ba-724d-82f1-ba0f73a67522.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e0ba-724d-82f1-ba0f73a67522",
        "storage_key": "property/6767906449165644/019d7913-e0ba-724d-82f1-ba0f73a67522.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://yellowcitystreetfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16344830293565435816&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "yellow-city-street-food-ycsf",
      "poi_latitude": "35.1932116",
      "poi_longitude": "-101.870328",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-353-9273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-99d96d832275",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKS-UolVOAYcRqO8Cqo2A1OI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_41937448-87e8-4dc4-89ca-3f737daf46c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Tyler's Barbeque",
      "poi_type": "Restaurants",
      "poi_address": "3301 Olsen Blvd, Amarillo, TX 79109, USA",
      "poi_short_description": "Down-home BBQ place in a little red house, serving dry-rub ribs smoked daily, plus brisket & sides.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, ribs, and pulled pork. They highlight the tender, juicy, and flavorful meat, as well as the excellent rub on the ribs and the tasty sides. They also like the reasonable prices and the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-e483-7178-9c84-6deda726b15c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e483-7178-9c84-6deda726b15c",
        "storage_key": "property/6767906449165644/019d7913-e483-7178-9c84-6deda726b15c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://tylersbarbeque.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13029359707188135794&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tyler-s-barbeque",
      "poi_latitude": "35.1842241",
      "poi_longitude": "-101.8760089",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 806-331-2271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-99d96d832275",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl-l84c5PAYcRcoe8BZ-V0bQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_eba97f97-9001-4246-a4d9-34bfd64bc073",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "O.H.M.S. Cafe & Bar",
      "poi_type": "Restaurants",
      "poi_address": "619 S Tyler St, Amarillo, TX 79101, USA",
      "poi_short_description": "Upscale American bistro offering a cafeteria-style lunch, table-service dinner & cocktails at night.",
      "poi_long_description": "People say this American restaurant offers delicious drinks, amazing food, and a fantastic wine list with something for everyone. They highlight the creative and delicious food, and the date night atmosphere. They also like the attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-ee5f-7527-adde-31bc45e9cc8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ee5f-7527-adde-31bc45e9cc8d",
        "storage_key": "property/6767906449165644/019d7913-ee5f-7527-adde-31bc45e9cc8d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.ohmscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12075563098798328632&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "o-h-m-s-cafe-bar",
      "poi_latitude": "35.2071876",
      "poi_longitude": "-101.8379297",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-373-3233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c4f-725b-b121-99d96d832275",
        "storage_key": "property/6767906449165644/019cfb4d-6c4f-725b-b121-99d96d832275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7tLqv5OAYcROIuwxqgElac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3393d466-4258-41e0-8a66-b3760b09d927",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Shops At Soncy",
      "poi_type": "Shopping & Retail",
      "poi_address": "3220 S Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Strip mall featuring a mix of stores, including Ross Dress for Less, Joann Fabrics, and Five Below.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-f0aa-727b-b064-5a158e3b90d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f0aa-727b-b064-5a158e3b90d7",
        "storage_key": "property/6767906449165644/019d7913-f0aa-727b-b064-5a158e3b90d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17047857852701740555&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "shops-at-soncy",
      "poi_latitude": "35.1795202",
      "poi_longitude": "-101.9392488",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c5a-7684-9d2e-e1a656388a34",
        "storage_key": "property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf8ncs_lQAYcRCw6kw2Qoluw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8669146d-480c-4cc3-bc28-c2947a1b74c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Alley Katz Unique Emporium",
      "poi_type": "Shopping & Retail",
      "poi_address": "2807 SW 6th Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "Store with 40-plus vendor booths offering antiques, vintage items, and Western wares.",
      "poi_long_description": "People say this antique store offers a wide variety of items, including vintage Murano glass, Victorian pieces, and knives. They highlight the good prices and fun, unique vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-f21f-70ad-a509-18f154f9691f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f21f-70ad-a509-18f154f9691f",
        "storage_key": "property/6767906449165644/019d7913-f21f-70ad-a509-18f154f9691f.webp",
        "width": 1280,
        "height": 523
      },
      "poi_business_url": "https://shopalleykatz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9073811183702026464&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "alley-katz-unique-emporium",
      "poi_latitude": "35.2111132",
      "poi_longitude": "-101.8678365",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-342-5432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c5a-7684-9d2e-e1a656388a34",
        "storage_key": "property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJq8FzPjhOAYcR4KiGSzKn7H0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_e4af40af-52bb-4e95-a92e-7220d57627bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Hide & Seek Treasures",
      "poi_type": "Shopping & Retail",
      "poi_address": "2917 SW 6th Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "Small shop featuring a variety of antiques, plus modern and sci-fi items.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-f4d2-772b-84dd-67dc7b209430.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f4d2-772b-84dd-67dc7b209430",
        "storage_key": "property/6767906449165644/019d7913-f4d2-772b-84dd-67dc7b209430.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2708838375892882911&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hide-seek-treasures",
      "poi_latitude": "35.2110368",
      "poi_longitude": "-101.869613",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 806-220-2551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c5a-7684-9d2e-e1a656388a34",
        "storage_key": "property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtx_WyTlOAYcR35UKnSa6lyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_c03ac0dc-a0b1-4443-ae67-f6ef209bdfcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "8201 I-40 W, Amarillo, TX 79121, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of items, including seasonal items, gifts, and household goods, at great prices. They also highlight the friendly and helpful staff, and many appreciate the convenient curbside pickup service.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-f71d-77ae-a130-c81d55150a2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f71d-77ae-a130-c81d55150a2e",
        "storage_key": "property/6767906449165644/019d7913-f71d-77ae-a130-c81d55150a2e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/amarillo/221",
      "poi_directions_map_url": "https://maps.google.com/?cid=2462063419515012103&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.1859504",
      "poi_longitude": "-101.934272",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-358-4030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c5a-7684-9d2e-e1a656388a34",
        "storage_key": "property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ5MuplBQAYcRBwStrqIBKyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_b3c7fcda-93a5-4890-b6ac-72fa9b562c97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "2610 S Soncy Rd, Amarillo, TX 79124, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "People say this department store offers a wide variety of clothing, including jumpers, hosiery, and Bermuda shorts, as well as household items and gifts. They also highlight the clean and organized store, the friendly and helpful staff, and the convenient Amazon return service.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-fb17-75b7-ac1e-8b19898f5322.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-fb17-75b7-ac1e-8b19898f5322",
        "storage_key": "property/6767906449165644/019d7913-fb17-75b7-ac1e-8b19898f5322.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kohls.com/stores/tx/amarillo-748.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5781794579058512761&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "35.1833149",
      "poi_longitude": "-101.9403343",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 806-354-8393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c5a-7684-9d2e-e1a656388a34",
        "storage_key": "property/6767906449165644/019cfb4d-6c5a-7684-9d2e-e1a656388a34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJb0qPkflQAYcRedMPUYkPPVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7b379813-d3c3-40f6-8b2b-69f87a98b035",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Amarillo Country Club",
      "poi_type": "Entertainment",
      "poi_address": "4800 Bushland Blvd, Amarillo, TX 79106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-fc47-76ae-a1c9-23d7858449cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-fc47-76ae-a1c9-23d7858449cf",
        "storage_key": "property/6767906449165644/019d7913-fc47-76ae-a1c9-23d7858449cf.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.theamarillocountryclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16451080557973186840&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amarillo-country-club",
      "poi_latitude": "35.2082862",
      "poi_longitude": "-101.8891525",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 806-355-3371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqUZ-jidOAYcRGKlTHZv6TeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_488e8869-1b68-4e97-a4da-fd6df61fa703",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Amarillo Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2200 S Van Buren St, Amarillo, TX 79109, USA",
      "poi_short_description": "Regional 20th-century art, including 4 Georgia O'Keeffe watercolors, plus a Pan-Asian collection.",
      "poi_long_description": "Regional 20th-century art, including 4 Georgia O'Keeffe watercolors, plus a Pan-Asian collection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7913-fe8e-740b-bcf2-ad89bdb3209a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-fe8e-740b-bcf2-ad89bdb3209a",
        "storage_key": "property/6767906449165644/019d7913-fe8e-740b-bcf2-ad89bdb3209a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.amoa.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=216dd4bc-81fb-4580-9828-ab80d0de8de8",
      "poi_directions_map_url": "https://maps.google.com/?cid=15566548492245588692&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amarillo-museum-of-art",
      "poi_latitude": "35.1885361",
      "poi_longitude": "-101.8451167",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 806-371-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c54-749c-9501-0b2e08b13f41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c54-749c-9501-0b2e08b13f41",
        "storage_key": "property/6767906449165644/019cfb4d-6c54-749c-9501-0b2e08b13f41.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ehFk6dPAYcR1Now62B9B9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_23321d82-4271-4299-864f-c02b915a2f25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Northwest Amarillo Public Library",
      "poi_type": "Entertainment",
      "poi_address": "6100 SW 9th Ave, Amarillo, TX 79106, USA",
      "poi_short_description": "Public library offering a range of materials, including DVDs, with a fee for non-residents.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7914-0083-71a3-bb30-08a1478c5cff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7914-0083-71a3-bb30-08a1478c5cff",
        "storage_key": "property/6767906449165644/019d7914-0083-71a3-bb30-08a1478c5cff.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.amarillolibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11346333683978400909&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northwest-amarillo-public-library",
      "poi_latitude": "35.2065708",
      "poi_longitude": "-101.9045931",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 806-359-2035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c48-7498-98eb-25f9293415f1",
        "storage_key": "property/6767906449165644/019cfb4d-6c48-7498-98eb-25f9293415f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJywSfY89RAYcRjfSUwF5Gdp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_108543de-b2d6-4f57-9f23-53efd1630594",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Jack Sisemore Traveland Rv Storage",
      "poi_type": "Entertainment",
      "poi_address": "14501 I-27, Amarillo, TX 79119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11062960764534641275&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jack-sisemore-traveland-rv-storage",
      "poi_latitude": "35.0604496",
      "poi_longitude": "-101.9182775",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c63-707f-99f4-b27e3a86bb40",
        "storage_key": "property/6767906449165644/019cfb4d-6c63-707f-99f4-b27e3a86bb40.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu24mJZxcAYcRe9IrhjOIh5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_78d7b7b6-d4cb-42c2-9f3f-83f6ef5eaead",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "American Quarter Horse Hall of Fame & Museum",
      "poi_type": "Entertainment",
      "poi_address": "2601 E Interstate Dr, Amarillo, TX 79104, USA",
      "poi_short_description": "Museum with interactive exhibits devoted to this famous horse breed & its history in America.",
      "poi_long_description": "People say this museum offers great exhibits on the horse in cinema, American Quarter Horse history, and the role of horses in settling the West. They highlight the interactive exhibits, the Hall of Fame section, and the beautiful building. They also like the friendly and kind staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7914-0286-7639-83ff-2e0d1cfc18ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7914-0286-7639-83ff-2e0d1cfc18ae",
        "storage_key": "property/6767906449165644/019d7914-0286-7639-83ff-2e0d1cfc18ae.webp",
        "width": 850,
        "height": 417
      },
      "poi_business_url": "http://aqha.com/museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=7295682578937935522&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "american-quarter-horse-hall-of-fame-museum",
      "poi_latitude": "35.1942386",
      "poi_longitude": "-101.8079849",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 806-376-5181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c54-749c-9501-0b2e08b13f41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c54-749c-9501-0b2e08b13f41",
        "storage_key": "property/6767906449165644/019cfb4d-6c54-749c-9501-0b2e08b13f41.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAbqJ1C9PAYcRovaZv6Z4P2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0a9aae91-a32c-4689-86ae-39a65b47a4cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Bill's Backyard Classics",
      "poi_type": "Entertainment",
      "poi_address": "5309 S Washington St, Amarillo, TX 79110, USA",
      "poi_short_description": "Sizable classic car museum featuring an array of makes & models dating back to the 1920s.",
      "poi_long_description": "People say this museum has an incredible collection of classic cars, lovingly restored and maintained in excellent condition. They highlight the vehicles are driveable and the tour guides are knowledgeable and engaging. They also like the personal tours and the informative walk-throughs of the cars and the history of the collection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d7914-05b2-77eb-a92c-2ca6b42a4d3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7914-05b2-77eb-a92c-2ca6b42a4d3d",
        "storage_key": "property/6767906449165644/019d7914-05b2-77eb-a92c-2ca6b42a4d3d.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "https://www.billsbackyardclassics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8333570560278974626&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bill-s-backyard-classics",
      "poi_latitude": "35.154351",
      "poi_longitude": "-101.8477999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 806-373-8194",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-6c54-749c-9501-0b2e08b13f41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-6c54-749c-9501-0b2e08b13f41",
        "storage_key": "property/6767906449165644/019cfb4d-6c54-749c-9501-0b2e08b13f41.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJY0Rzl35FAYcRotAUfEXKpnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a1dac554-8704-46d0-ab54-d3ecfbb968d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Saigon Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "saigon-restaurant",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1d059214-8616-47a6-9ac1-3309eb00a2dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Georgia Street Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "georgia-street-mall",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d957fe3f-0f18-4b5d-b7e9-3ae22b0f2496",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Medical Center Park",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "medical-center-park",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0fae0292-0532-40bc-b77b-d88dca4138a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "poi_name": "Route 66 Historic District",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "route-66-historic-district",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_32308190d66c076d3bb52f35",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7094a58adceda6ec5a8da252",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7a2e329b7efd95b6fd39e06f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_10a54eb9ce4457b13e43349d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_1c3770b194b949cfa0f62373",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_aebcd998a85036b25d644d14",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_84573f57-ddba-4950-8918-54f477321089",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "rating": "5.0",
      "name": "Albert Flores",
      "text": "Apartments are great very green very clean and very peaceful. Staff is super nice and Ryan always helpful. This is our first time in Amarillo and by far best choice we made to live at these apartments.",
      "date": "2025-08-22",
      "title": ""
    },
    {
      "id": "custom_60280783-0291-4212-aa87-d7e2e8334fb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "rating": "5.0",
      "name": "Oscar Herrera",
      "text": "I'm about 12 years in, living here, and couldn't ask for a better community to live in!  The entire staff make this community wonderful!  Ryan and Stephanie are the best, and are prompt with any request needed.  The grounds staff work hard to keep everything looking fresh.  Great location near shopping, restaurants, and Rt 66!  Would recommend,  5/5!!!",
      "date": "2025-10-07",
      "title": ""
    },
    {
      "id": "custom_77b911aa-d0d9-41de-be71-213a526ddbb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "rating": "5.0",
      "name": "Robert Barham",
      "text": "I’ve lived on this properly for nearly 12 years now. No property in the world one person lives in is gonna be perfect regardless of whether it’s a $10 million mansion or an apartment/loft like mine. But this complex and the staff that operates it Continue to exceed my expectations. It’s been a very great place to live for the last 12 years. If you pay your rent and you take care of the property when you have an issue, they’re gonna Attempt to help you as best they can.",
      "date": "2025-09-22",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_d9a207b3-101b-4868-8d2a-6e28ef75d3a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4e-06a8-714a-8c9d-284d3f6cbca6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of apartment complex pool area with lounge chairs.",
        "public_id": "019cfb4e-06a8-714a-8c9d-284d3f6cbca6",
        "storage_key": "property/6767906449165644/019cfb4e-06a8-714a-8c9d-284d3f6cbca6.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Winchester Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f69fb2304adcd5d324f6f08&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-89de-7432-b6e5-4d25d05550cd",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "winchester-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644"
    },
    {
      "lead_collector_id": "019cf79e-8a56-738c-8155-29108f92cee2",
      "lead_source": "LANDING_PAGE",
      "name": "winchester-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "apartments-with-air-conditioning-amarillo-tx",
      "search_query": "apartments with air conditioning amarillo tx",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Amarillo",
      "h2_subtitle": "Stay cool in Amarillo with our air-conditioned apartments. Winchester Apartments offer the perfect blend of comfort and convenience in Texas.",
      "page_copy": "Discover the comfort of air-conditioned living at Winchester Apartments in Amarillo, TX. Our community features modern one, two, and three-bedroom homes where air conditioning comes standard, ensuring you stay comfortable year-round. Located in the heart of Amarillo, our apartments provide a perfect escape from the Texas heat. \n\nWinchester Apartments aren't just about comfort—they also provide access to top-notch amenities. Relax by the refreshing pool, work up a sweat in our fitness center, or simply unwind in the inviting clubhouse. With air-conditioned spaces throughout your home, you'll love every moment spent at Winchester Apartments in Amarillo, TX. Schedule a tour today and experience it for yourself!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioning Apartments in Amarillo, TX",
      "seo_description": "Stay comfortable in Amarillo, TX with Winchester Apartments, featuring air-conditioned homes and top amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "modern-apartments-with-dishwasher-amarillo",
      "search_query": "modern apartments with dishwasher amarillo",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Dishwasher in Amarillo",
      "h2_subtitle": "Upgrade your lifestyle in Amarillo with a modern apartment featuring a dishwasher. Experience convenience at Winchester Apartments.",
      "page_copy": "Experience modern living at Winchester Apartments in Amarillo, where convenience meets style. Our thoughtfully designed one, two, and three-bedroom apartments come equipped with a dishwasher, making mealtime cleanup a breeze. Enjoy a contemporary lifestyle with all the modern amenities you need right at home.\n\nBeyond the comforts of a dishwasher, Winchester Apartments offer a variety of amenities to enhance your living experience. Dive into relaxation at our sparkling pool or keep active in our well-equipped fitness center. Nestled in the heart of Amarillo, our community offers both convenience and comfort. Discover your new home today at Winchester Apartments, where modern amenities are part of everyday life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Dishwasher in Amarillo",
      "seo_description": "Discover modern living at Winchester Apartments in Amarillo, featuring homes with dishwashers and excellent amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "amarillo-apartments-with-pool-79106",
      "search_query": "amarillo apartments with pool 79106",
      "category": "Amenity",
      "h1_title": "Amarillo Apartments with Pool in 79106",
      "h2_subtitle": "Dive into relaxation at Winchester Apartments in Amarillo. Our community in the 79106 area offers apartment living with a pool and great amenities.",
      "page_copy": "Winchester Apartments, located in the vibrant 79106 area of Amarillo, TX, is your perfect retreat offering the ideal living experience with a sparkling pool at your doorstep. Our beautifully designed one, two, and three-bedroom apartments provide the perfect blend of comfort and convenience, all enhanced by top-notch amenities including refreshing pool access.\n\nWhether you're going for an invigorating morning swim or lounging around on a sunny afternoon, our pool is central to the Winchester Apartments experience. Add in features like our modern fitness center and lively clubhouse, and you've got a community that truly feels like home. Experience it for yourself by scheduling a tour today and diving into the comfort of our community!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Amarillo Apartments with Pool in 79106",
      "seo_description": "Explore Winchester Apartments with a pool in Amarillo's 79106 area. Enjoy modern amenities and a great location. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-amarillo-texas",
      "search_query": "apartments with fitness center amarillo texas",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Amarillo, TX",
      "h2_subtitle": "Achieve your fitness goals at Winchester Apartments in Amarillo, Texas. Enjoy our fully-equipped fitness center right at home.",
      "page_copy": "Stay healthy and active at Winchester Apartments in Amarillo, TX. Our community proudly offers a fully-equipped fitness center available to all residents, giving you the convenience of modern workout facilities just steps from your door. Our one, two, and three-bedroom apartments are designed to support an active lifestyle combined with the comfort of contemporary living.\n\nBeyond the fitness center, Winchester Apartments provides a plethora of amenities that cater to diverse interests. Whether you're lounging by the pool, dining on takeout with the ease of in-home amenities like dishwashers, or socializing in the welcoming clubhouse, our community is designed for your lifestyle needs. Visit us today and see how you can maintain a vibrant fitness routine while enjoying all the comforts of home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Amarillo, TX Apartments with Fitness Center",
      "seo_description": "Discover Winchester Apartments in Amarillo, TX featuring a fitness center and modern amenities. Achieve your fitness goals at home. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "gated-apartments-southwestern-amarillo",
      "search_query": "gated apartments southwestern amarillo",
      "category": "Amenity",
      "h1_title": "Gated Apartments in Southwestern Amarillo",
      "h2_subtitle": "Discover the comfort and security of gated living at Winchester Apartments in Southwestern Amarillo. Enjoy peace of mind with our exclusive gated community.",
      "page_copy": "At Winchester Apartments, located in the charming area of Southwestern Amarillo, you can enjoy the benefits of living in a gated community. Our beautifully designed apartments offer peace of mind with enhanced security, while providing everything you need for a modern lifestyle.\n\nBeyond the gated entrance, you will find a host of amenities designed to enrich your living experience. With a refreshing pool, well-equipped fitness center, and a cozy clubhouse, Winchester Apartments offers a sanctuary where comfort and convenience blend seamlessly. Discover the ideal place to call home in our secure and friendly community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Apartments in Southwestern Amarillo",
      "seo_description": "Explore Winchester Apartments in Southwestern Amarillo, a gated community offering security and comfort. Discover your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-amarillo",
      "search_query": "one bedroom apartments amarillo",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Amarillo",
      "h2_subtitle": "Find your ideal one bedroom apartment at Winchester Apartments in Amarillo. Enjoy modern amenities designed for comfort and convenience.",
      "page_copy": "Winchester Apartments in Amarillo is perfect for individuals seeking stylish and comfortable one bedroom apartments. Our thoughtfully crafted units provide a welcoming atmosphere, paired with modern amenities that make daily living a delight. With features such as hardwood floors and cable ready setups, you'll find everything you need right in your apartment.\n\nLocated in a vibrant community, residents also enjoy the luxury of onsite amenities including a sparkling pool and an inviting fitness center. Explore our one bedroom apartments and experience a lifestyle where relaxation meets convenience in beautiful Amarillo, Texas. Schedule a tour and discover your next home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Amarillo",
      "seo_description": "Discover Winchester Apartments' one bedroom options in Amarillo, TX. Enjoy modern amenities and a vibrant community. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-southwest-amarillo",
      "search_query": "2 bedroom apartments in Southwest Amarillo",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Southwest Amarillo",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at Winchester Apartments in Southwest Amarillo. Perfect for comfort and convenience.",
      "page_copy": "Located in the serene environment of Southwest Amarillo, Winchester Apartments offers spacious and well-designed 2 bedroom apartments ideal for couples or small families. Each unit is equipped with modern features, including hardwood floors and tub/shower combos, ensuring a comfortable living experience. Our apartments provide all the essentials needed for modern living, combined with the charm of the Southwest.\n\nLiving here also means access to a wide range of community amenities such as a sparkling pool and a fully-equipped fitness center. Whether you are lounging by the pool or working out, life at Winchester Apartments caters to your needs. Visit us today to discover the perfect blend of comfort and style in our 2 bedroom units located in this desirable part of Amarillo.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Southwest Amarillo",
      "seo_description": "Discover spacious 2 bedroom apartments at Winchester in Southwest Amarillo with modern amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-79106",
      "search_query": "three bedroom apartments near 79106",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 79106",
      "h2_subtitle": "Explore spacious three bedroom apartments at Winchester Apartments near the 79106 area. Perfect for families needing extra space in Amarillo.",
      "page_copy": "If you're searching for spacious three bedroom apartments near the 79106 area, look no further than Winchester Apartments. Situated in a convenient location in Amarillo, our apartments offer ample space perfect for families or those needing extra room. Each unit is designed with contemporary features, including hardwood floors and cable-ready access, ensuring you have everything you need for a modern lifestyle.\n\nResidents also enjoy a variety of community amenities. Take a refreshing dip in our pool, stay active in the fitness center, or unwind in our welcoming clubhouse. Winchester Apartments brings together comfort, convenience, and community living in a location that makes getting around Amarillo easy and efficient. Tour our three bedroom options today and discover your ideal home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 79106",
      "seo_description": "Discover three bedroom apartments near the 79106 area at Winchester Apartments. Spacious and modern living awaits in Amarillo, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "apartments-near-amarillo-college-amarillo",
      "search_query": "apartments near Amarillo College Amarillo",
      "category": "School",
      "h1_title": "Apartments Near Amarillo College, Amarillo",
      "h2_subtitle": "Discover ideal living at Winchester Apartments, conveniently located near Amarillo College. Enjoy modern amenities and a welcoming environment.",
      "page_copy": "Winchester Apartments offers an ideal living space conveniently located near Amarillo College in Amarillo, Texas. Perfect for students, faculty, or anyone seeking a vibrant community, our apartments provide an excellent balance of accessibility and modern comfort. Each unit is thoughtfully designed with contemporary features, such as hardwood floors and cable readiness, providing all the necessities for a comfortable lifestyle.\n\nClose to campus, residents can easily commute while also enjoying premium on-site amenities. Whether you are taking a dip in the pool, keeping fit in the gym, or relaxing in the clubhouse, Winchester Apartments delivers a warm and welcoming environment tailored to meet diverse lifestyle needs. Discover our beautiful apartments near Amarillo College and make them your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Amarillo College, Amarillo",
      "seo_description": "Explore Winchester Apartments, the perfect living option near Amarillo College. Enjoy modern amenities and convenient access in Amarillo, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "rental-homes-close-to-amarillo-college-west-campus-79106",
      "search_query": "rental homes close to Amarillo College West Campus 79106",
      "category": "School",
      "h1_title": "Rental Homes Close to Amarillo College West Campus",
      "h2_subtitle": "Find rental homes conveniently located near Amarillo College West Campus, 79106. Experience comfort and convenience in Amarillo.",
      "page_copy": "Winchester Apartments offers the perfect rental homes close to Amarillo College West Campus in the 79106 area. Our units are designed to provide an ideal living setting for students, educators, or anyone who values proximity to education and community hubs. Featuring modern amenities like hardwood floors and high-speed internet readiness, our apartments cater to a variety of needs and lifestyles.\n\nThe community is enriched with facilities that enhance daily living. Residents can relax by the pool, engage in fitness activities in our well-equipped gym, or enjoy socializing in the clubhouse. Located just a short distance from Amarillo College West Campus, Winchester Apartments offers a harmonious blend of comfort and convenience, embodying a vibrant lifestyle in Amarillo. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Close to Amarillo College West Campus",
      "seo_description": "Discover rental homes near Amarillo College West Campus, 79106 at Winchester Apartments, offering comfortable and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "apartments-near-bsa-hospital-amarillo-tx",
      "search_query": "apartments near BSA Hospital Amarillo TX",
      "category": "Hospital",
      "h1_title": "Apartments Near BSA Hospital, Amarillo TX",
      "h2_subtitle": "Explore our convenient apartments located near BSA Hospital in Amarillo, TX. Enjoy a blend of comfort and accessibility.",
      "page_copy": "Winchester Apartments provides ideal accommodation for those looking for apartments near BSA Hospital in Amarillo, TX. Located just minutes from the hospital, our community offers an excellent choice for healthcare professionals, patients, and their families seeking a comfortable and convenient living option. Our modern apartments feature hardwood floors, include cable-ready setups, and are equipped with stylish amenities to enhance your living experience.\n\nResidents of Winchester Apartments enjoy an array of on-site facilities suited for relaxation and fitness. Whether you’re relaxing in the pool, staying active in our fitness center, or mingling in the clubhouse, our community offers a supportive environment just a stone's throw from BSA Hospital. Opt for Winchester Apartments and relish in the perfect combination of location and lifestyle. Schedule your tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near BSA Hospital, Amarillo TX",
      "seo_description": "Discover comfortable living at Winchester Apartments, conveniently located near BSA Hospital in Amarillo, TX. Enjoy modern amenities and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "winchester-apartments-close-to-northwest-texas-healthcare-system-79106",
      "search_query": "Winchester Apartments close to Northwest Texas Healthcare System 79106",
      "category": "Hospital",
      "h1_title": "Winchester Apartments Near Northwest Texas Healthcare",
      "h2_subtitle": "Live close to Northwest Texas Healthcare System in 79106 at Winchester Apartments. Enjoy modern living and convenience in Amarillo.",
      "page_copy": "If you're looking for a home close to Northwest Texas Healthcare System within the 79106 area, Winchester Apartments is your ideal choice. Located conveniently near the healthcare facility, our community caters especially to healthcare professionals and those seeking proximity to one of Amarillo's premier healthcare systems. Each apartment is designed with thoughtful amenities, including hardwood floors and cable-ready configurations, ensuring a comfortable and connected lifestyle.\n\nWinchester Apartments offers more than just location; it offers a vibrant community with excellent on-site amenities. Residents can unwind by our pool, keep energetic in our fitness center, or enjoy the serene atmosphere of our clubhouse. With a perfect blend of location and lifestyle amenities, Winchester Apartments is where comfort meets convenience near Northwest Texas Healthcare System. Come visit us and explore your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Winchester Apartments Near Northwest Texas Healthcare",
      "seo_description": "Find modern living near Northwest Texas Healthcare System at Winchester Apartments, 79106. Experience comfort and convenient access in Amarillo.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "apartments-near-amarillo-botanical-gardens",
      "search_query": "apartments near amarillo botanical gardens",
      "category": "Park",
      "h1_title": "Apartments Near Amarillo Botanical Gardens",
      "h2_subtitle": "Discover Winchester Apartments near the Amarillo Botanical Gardens. Experience the beauty and ease of living close to nature in Amarillo.",
      "page_copy": "At Winchester Apartments, you'll find the perfect place to live near the stunning Amarillo Botanical Gardens. Nestled in a prime location, our community offers the tranquility that comes with being close to nature, while providing modern amenities and comforts. Our homes are equipped with beautiful hardwood floors, spacious tubs, and are cable ready, ensuring a seamless living experience for all residents.\n\nWhether you're a nature enthusiast or simply enjoy a peaceful environment, Winchester Apartments places you just minutes away from the vibrant landscapes of the gardens. Relax by the pool after a garden stroll, keep fit in our gym, or socialize in the clubhouse. Choose Winchester Apartments for a harmonious blend of natural beauty and urban convenience. Schedule a visit today and see why our community stands out in Amarillo.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Amarillo Botanical Gardens",
      "seo_description": "Live near the Amarillo Botanical Gardens at Winchester Apartments. Experience convenient, modern living surrounded by natural beauty in Amarillo.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "winchester-apartments-close-to-john-stiff-memorial-park",
      "search_query": "winchester apartments close to john stiff memorial park",
      "category": "Park",
      "h1_title": "Winchester Apartments Near John Stiff Memorial Park",
      "h2_subtitle": "Winchester Apartments offers a prime location close to John Stiff Memorial Park. Enjoy nearby recreational activities in Amarillo.",
      "page_copy": "Experience the perfect balance of comfort and convenience at Winchester Apartments, situated just minutes from John Stiff Memorial Park in Amarillo. Our community is a fantastic choice for those seeking apartments close to this beautiful green space, offering ample opportunities for outdoor recreation and relaxation. Each apartment is thoughtfully designed, featuring hardwood floors, tub/shower combinations, and cable-ready setups to ensure a modern lifestyle.\n\nLiving at Winchester Apartments means you can enjoy the best of both worlds—easy access to the natural beauty of John Stiff Memorial Park while still enjoying on-site amenities like a fitness center, refreshing pool, and inviting clubhouse. Relish in the vibrant community atmosphere and proximity to popular local attractions. Choose Winchester Apartments for a dynamic and fulfilling living experience near one of Amarillo's central parks.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Winchester Apartments Near John Stiff Memorial Park",
      "seo_description": "Discover Winchester Apartments close to John Stiff Memorial Park in Amarillo. Enjoy modern living with easy access to recreation and nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "living-near-thompson-memorial-park-amarillo-tx",
      "search_query": "living near thompson memorial park amarillo tx",
      "category": "Park",
      "h1_title": "Living Near Thompson Memorial Park Amarillo",
      "h2_subtitle": "Explore Winchester Apartments for a lifestyle near Thompson Memorial Park in Amarillo, TX. Enjoy the perks of nature just steps away.",
      "page_copy": "Winchester Apartments offers an ideal setting for those who desire living near Thompson Memorial Park in Amarillo, TX. Our community provides a harmonious blend of nature and modern convenience, right next to one of Amarillo's beloved recreational areas. Inside our apartments, you'll find thoughtful designs with modern amenities such as hardwood floors, tub/shower options, and cable-ready access, all curated for a comfortable lifestyle.\n\nBeing minutes away from Thompson Memorial Park means having easy access to walking trails, picnic spots, and open spaces perfect for gatherings or relaxation. Plus, residents can take advantage of our on-site amenities, like the sparkling pool and energizing fitness center. At Winchester Apartments, you can enjoy both the serenity of nature and the vibrancy of community living. Discover your new home today, perfectly positioned for both relaxation and recreation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Thompson Memorial Park in Amarillo",
      "seo_description": "Experience Winchester Apartments near Thompson Memorial Park, Amarillo, TX. Enjoy nature's beauty and modern amenities in your new home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165644",
      "source": "generator",
      "page_item_url": "amarillo-tx-apartments-near-wildcat-bluff-nature-center",
      "search_query": "amarillo tx apartments near wildcat bluff nature center",
      "category": "Park",
      "h1_title": "Apartments Near Wildcat Bluff Nature Center",
      "h2_subtitle": "Explore Winchester Apartments in Amarillo, TX, located near the scenic Wildcat Bluff Nature Center. Experience nature's charm close to home.",
      "page_copy": "Discover Winchester Apartments, perfectly situated in Amarillo, TX, just a short distance from the enchanting Wildcat Bluff Nature Center. Our community offers the ideal retreat for those who value living close to nature while enjoying modern conveniences. Each home is equipped with premium features like stylish hardwood floors, a convenient tub/shower, and a cable-ready setup, designed to enhance your daily life.\n\nResidents at Winchester Apartments enjoy easy access to the scenic trails and natural beauty of Wildcat Bluff Nature Center, making it simple to immerse themselves in outdoor adventures. After a day of exploring, unwind by our on-site pool or connect with neighbors in our welcoming clubhouse. Winchester Apartments provides a unique blend of nature and comfortable living, creating a vibrant community in the heart of Amarillo.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area. Large windows provide natural light.",
        "public_id": "019cfb4d-4adc-7759-a40a-f872462f22a7",
        "storage_key": "property/6767906449165644/019cfb4d-4adc-7759-a40a-f872462f22a7.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Amarillo TX Apartments Near Wildcat Bluff Nature Center",
      "seo_description": "Find Winchester Apartments in Amarillo, TX, near Wildcat Bluff Nature Center. Enjoy nature-friendly living with modern amenities nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5233"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-NHLYNFTJ81"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151733"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/winchester/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P68JJ59W"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165644/019d1bdb-013e-7588-b45d-0e80626a35c6.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "5059653703"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "bfac29d9-610f-4dda-9cff-e2c40236f40d"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "855-970-0316"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6504af77254f56be3952b293"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlMxUW80NmtBWlNDRlJpWjk5ZGhnY0E9PSIsInZhbHVlIjoiM2RkNFFsN09nRVZaVDlnLzhhUFdMQT09IiwibWFjIjoiMDA5MjRiODgyN2U1MzEyMDA0OWY4Y2FmYjJkZWI5Yzg5NTZjYWFhNTMzZmY1ODhkYjJmYzQxMWQ5MWExZWIxZSJ9"
    }
  ],
  "custom_qb_id": "5233",
  "custom_ga4_id": "G-NHLYNFTJ81",
  "custom_repli_id": "10041151733",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/winchester/register/",
  "custom_google_gtm_id": "GTM-P68JJ59W",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165644/019d1bdb-013e-7588-b45d-0e80626a35c6.pdf",
  "custom_hubspot_company_id": "5059653703",
  "custom_rentgrata_property_id": "bfac29d9-610f-4dda-9cff-e2c40236f40d",
  "custom_ppc_tracking_phone_number": "855-970-0316",
  "custom_residentboost_apartment_id": "6504af77254f56be3952b293",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlMxUW80NmtBWlNDRlJpWjk5ZGhnY0E9PSIsInZhbHVlIjoiM2RkNFFsN09nRVZaVDlnLzhhUFdMQT09IiwibWFjIjoiMDA5MjRiODgyN2U1MzEyMDA0OWY4Y2FmYjJkZWI5Yzg5NTZjYWFhNTMzZmY1ODhkYjJmYzQxMWQ5MWExZWIxZSJ9"
};

export const generatedAt = '2026-08-27T21:34:37.947Z';
